import { Injectable } from "@angular/core";
import { FoodHandler } from "../models/food-handler";

const allFoodHandler: FoodHandler[] = [
  { id: 0, name: "PRODUCTION & OPERATIONS MANAGER (RESTAURANTS)" },
  { id: 1, name: "FOOD SERVICE SUPERVISOR (GOV)" },
  { id: 2, name: "FOOD SERVICE MANAGER" },
  { id: 3, name: "FOOD AND BEVERAGE DIRECTOR" },
  { id: 4, name: "FOOD AND BEVERAGE MANAGER" },
  { id: 5, name: "FOOD SERVICE SUPERVISOR" },
  { id: 5, name: "Hotel and restaurant manager" },
  { id: 5, name: "ASSISTANT FOOD AND BEVERAGE MANAGER" },
  { id: 5, name: "CATERING SERVICES GENERAL MANAGER" },
  { id: 5, name: "RESTAURANT GENERAL MANAGER" },
  { id: 5, name: "CAFÃ? PROPRIETOR" },
  { id: 5, name: "CATERING PROPRIETOR" },
  { id: 5, name: "RESTAURANT PROPRIETOR" },
  { id: 5, name: "FOOD AND BEVERAGE SUPERVISOR" },
  { id: 5, name: "BANQUET SUPERVISOR" },
  { id: 5, name: "RESTAURANT SUPERVISOR" },
  { id: 5, name: "DIETETIC/FOOD PROCESSING CONSULTANT" },
  { id: 5, name: "DIETITIAN (GENERAL)" },
  { id: 5, name: "THERAPEUTIC/CLINIC DIETITIAN" },
  { id: 5, name: "NUTRITIONIST (GENERAL)" },
  { id: 5, name: "COMMUNITY/PUBLIC HEALTH NUTRITIONIST" },
  { id: 5, name: "DIETARY NUTRITIONIST" },
  { id: 5, name: "FOOD AND NUTRITION SPECIALISTS" },
  { id: 5, name: "NUTRITIONIST-DIETITIAN" },
  { id: 5, name: "BANQUET COORDINATOR" },
  { id: 5, name: "STEWARD/STEWARDESS" },
  { id: 5, name: "HOUSE STEWARD" },
  { id: 5, name: "FOOD SERVICES HELPER (GOV)" },
  { id: 5, name: "FOOD SERVICE DISPATCHER" },
  { id: 5, name: "HEAD COOK" },
  { id: 5, name: "SHIP COOK" },
  { id: 5, name: "COOK (GENERAL)" },
  { id: 5, name: "ASSISTANT COOK" },
  { id: 5, name: "CHEF (GOV)" },
  { id: 5, name: "COOK A (GOV)" },
  { id: 5, name: "COOK I (GOV)" },
  { id: 5, name: "COOK II (GOV)" },
  { id: 5, name: "COOK II (GOV)" },
  { id: 5, name: "ASSISTANT CHEF" },
  { id: 5, name: "CHEF D 'PARTIE GARDEMANGER" },
  { id: 5, name: "CHEF D 'PARTIE BUTCHER" },
  { id: 5, name: "CHEF D 'PARTIE ENTREMETIER" },
  { id: 5, name: "LEAD CHEF" },
  { id: 5, name: "KITCHEN SUPERVISOR" },
  { id: 5, name: "CHEF" },
  { id: 5, name: "SOUS CHEF" },
  { id: 5, name: "ROASTING COOK" },
  { id: 5, name: "COMMIS CHEF" },
  { id: 5, name: "BAR KEEPER" },
  { id: 5, name: "BARTENDER" },
  { id: 5, name: "BARTENDER HELPER" },
  { id: 5, name: "FORMAL SERVICE WAITER" },
  { id: 5, name: "WAITER (GENERAL)" },
  { id: 5, name: "HEAD WAITER" },
  { id: 5, name: "WINE WAITER" },
  { id: 5, name: "WAITRESS/Watier" },
  { id: 5, name: "SERVICE CREW" },
  { id: 5, name: "FOOD SERVER" },
  { id: 5, name: "WAITER A (GOV)" },
  { id: 5, name: "FOOD ATTENDANT" },
  { id: 5, name: "HEAD WAITRESS" },
  { id: 5, name: "FOOD CHECKER" },
  { id: 5, name: "BARMAID" },
  { id: 5, name: "HOSPITAL AIDE" },
  { id: 5, name: "NURSERY AIDE" },
  { id: 5, name: "NURSING AIDE" },
  { id: 5, name: "HOSPITAL ATTENDANT" },
  { id: 5, name: "NURSING AIDE (HOME)" },
  { id: 5, name: "CAREGIVER (HOME-BASED)" },
  { id: 5, name: "PERSONAL MAID" },
  { id: 5, name: "BOUNCER" },
  { id: 5, name: "RETAIL/WHOLESALE ESTABLISHMENT SALESPERSON" },
  { id: 5, name: "SALESLADY" },
  { id: 5, name: "MERCHANDISER" },
  { id: 5, name: "SALES CLERK" },
  { id: 5, name: "WHOLESALE AND RETAIL TRADE SALESMAN" },
  { id: 5, name: "MERCHANDISING ASSISTANT" },
  { id: 5, name: "PROMO STAFF" },
  { id: 5, name: "MERCHANDISING OFFICER" },
  { id: 5, name: "PACKAGE COUNTER CLERK" },
  { id: 5, name: "DISPATCHER (SALES SERVICES)" },
  { id: 5, name: "MARKET SALESPERSON" },
  { id: 5, name: "STALL SALESPERSON" },
  { id: 5, name: "STREET STALL SALESPERSON" },
  { id: 5, name: "KIOSK SALESPERSON" },
  { id: 5, name: "STORE SALESPERSON" },
  { id: 5, name: "CABBAGE FARMER" },
  { id: 5, name: "ROOT VEGETABLE FARMER" },
  { id: 5, name: "TOMATO FARMER" },
  { id: 5, name: "VEGETABLE FARMER" },
  { id: 5, name: "AGAVE FARMER" },
  { id: 5, name: "SWEET POTATO FARMER" },
  { id: 5, name: "VINEYARD FARMER" },
  { id: 5, name: "GRAPEVINE FARMER" },
  { id: 5, name: "PASSION FRUIT FARMER" },
  { id: 5, name: "DAIRY FARMER" },
  { id: 5, name: "DAIRY FARMER" },
  { id: 5, name: "HOG RAISER" },
  { id: 5, name: "CHICKEN/EGGLAYER/MEATLAYER FARMER" },
  { id: 5, name: "CHICKEN MEAT PRODUCER" },
  { id: 5, name: "BANGUS FARM CULTIVATOR" },
  { id: 5, name: "PUMPING-STATION WATER OPERATOR" },
  { id: 5, name: "STATIONARY ENGINE OPERATOR (GENERAL)" },
  { id: 5, name: "WATER PURIFICATION PLANT OPERATOR" },
  { id: 5, name: "WATER TREATMENT PLANT OPERATOR" },
  { id: 5, name: "WATER PUMP OPERATOR (GOV)" },
  { id: 5, name: "WATER RESOURCES FACILITIES TENDER (GOV)" },
  { id: 5, name: "ICE PLANT OPERATOR" },
  { id: 5, name: "SCALER (GOV)" },
  { id: 5, name: "STREET AMBULANT VENDOR" },
  { id: 5, name: "KITCHEN HELPER" },
  { id: 5, name: "COMMIS HELPER" },
  { id: 5, name: "BUSBOY/BUSGIRL" },
  { id: 5, name: "DORMITORY ATTENDANT (GOV)" },
  { id: 5, name: "BUSGIRL" },
  { id: 5, name: "KITCHEN CREW" },
  { id: 5, name: "DISHWASHER" },
  { id: 5, name: "CHECKER" },
  { id: 5, name: "STOCKMAN" },
  { id: 5, name: "BAGGER" },
  { id: 5, name: "DELIVERY CHECKER" },
  { id: 5, name: "STORE HELPER" },
  { id: 5, name: "LIVESTOCK LABORER" },
  { id: 5, name: "POULTRY FARM LABORER" },
  { id: 5, name: "LIVESTOCK WORKER" },
  { id: 5, name: "FRUIT PICKER" },
  { id: 5, name: "POULTRY FARM WORKER" },
  { id: 5, name: "VINEYARD WORKER" },
  { id: 5, name: "HAND PACKER" },
  { id: 5, name: "PRODUCTION HELPER" },
];

const allNonFoodHandler: any[] = [
  { id: 0, name: "STAFF OFFICER (AFP)" },
  { id: 1, name: "MILITARY POLICE" },
  { id: 2, name: "OFFICER AFP NOT ELSEWHERE CLASSIFIED" },
  { id: 3, name: "COMBAT SOLDIER (AFP)" },
  { id: 4, name: "SERVICE AND RELATED WORKERS (AFP)" },
  { id: 5, name: "ADMINISTRATOR (GOV)" },
  { id: 6, name: "AMBASSADOR" },
  { id: 7, name: "CAREER EXECUTIVE SERVICE OFFICER" },
  { id: 8, name: "COMMISSIONER" },
  { id: 9, name: "DIRECTOR GENERAL" },
  { id: 10, name: "DIRECTOR GOVERNMENT AGENCY" },
  { id: 11, name: "GOVERNMENT ADMINISTRATOR" },
  { id: 12, name: "GENERAL MANAGER (GOV)" },
  { id: 13, name: "ASSISTANT ADMINISTRATOR (GOV)" },
  { id: 14, name: "ASSISTANT COMMISSIONER (CONSTITUTIONAL COMMISSION) (GOV)" },
  { id: 15, name: "ASSISTANT PRESS SECRETARY (GOV)" },
  { id: 16, name: "ASSOCIATE COMMISSIONER (GOV)" },
  { id: 17, name: "DISTRICT ENGINEER (GOV)" },
  { id: 18, name: "PRESIDENT/GENERAL MANAGER/ADMINISTRATOR (GOV)" },
  { id: 19, name: "MANAGER (GOV)" },
  { id: 20, name: "SECRETARY GENERAL" },
  { id: 21, name: "ADMINISTRATOR" },
  { id: 22, name: "ASSISTANT SECRETARY (GOV)" },
  { id: 23, name: "CHIEF EXECUTIVE STAFF (GOV)" },
  { id: 25, name: "MEMBER OF THE MUNICIPAL COUNCIL (SANGGUNIANG PAMBAYAN)" },
  { id: 26, name: "CORPORATE CHIEF EXECUTIVE" },
  { id: 27, name: "CORPORATE DIRECTOR" },
  { id: 28, name: "ASSISTANT EXECUTIVE SECRETARY (GOV)" },
  { id: 29, name: "SECRETARY, SOCIAL SECURITY COMMISSION (GOV)" },
  { id: 30, name: "MEMORIAL TRUST ADMINISTRATOR" },
  { id: 31, name: "MARKETING DIRECTOR" },
  { id: 32, name: "SALES DIRECTOR" },
  { id: 33, name: "PRESIDENT AND CEO (GOV)" },
  { id: 34, name: "OPERATIONS MANAGER" },
  { id: 35, name: "CONSTRUCTION MANAGER" },
  { id: 36, name: "ASSISTANT OPERATIONS MANAGER" },
  { id: 37, name: "PRODUCTION & OPERATIONS MANAGER (WHOLESALE & TRADE)" },
  { id: 38, name: "AVIATION MANAGER" },
  { id: 39, name: "PRODUCTION & OPERATIONS MANAGER (STORAGE)" },
  { id: 40, name: "PRODUCTION & OPERATIONS MANAGER (COMMUNICATIONS)" },
  { id: 41, name: "TRANSPORTATION MANAGER" },
  { id: 42, name: "WAREHOUSE MANAGER" },
  { id: 43, name: "EXPRESS MAIL CENTER MANAGER (GOV)" },
  { id: 44, name: "SHIPPING MANAGER" },
  { id: 45, name: "MAINTENANCE MANAGER" },
  { id: 46, name: "BROADCAST STATION MANAGER" },
  { id: 47, name: "PRODUCTION & OPERATIONS MANAGER (BUSINESS SERVICES)" },
  { id: 48, name: "GENERAL MANAGER (GFI - SG-30)" },
  { id: 49, name: "REGIONAL MANAGER (GOV)" },
  { id: 50, name: "BRANCH MANAGER" },
  { id: 51, name: "BRANCH HEAD (GOV)" },
  { id: 52, name: "CLEANING SERVICES MANAGER" },
  { id: 53, name: "PERSONAL CARE SERVICES MANAGER" },
  { id: 54, name: "PRODUCTION & OPERATIONS MANAGER (PERSONAL CARE)" },
  { id: 55, name: "PROJECT MANAGER" },
  { id: 56, name: "UNIVERSITY DEAN" },
  { id: 57, name: "COLLEGE ADMINISTRATOR (GOV)" },
  { id: 58, name: "PLANNING MANAGER" },
  { id: 59, name: "COLLEGE DEAN" },
  { id: 60, name: "COLLEGE ADMINISTRATOR" },
  { id: 61, name: "COLLEGE DEPARTMENT HEAD" },
  { id: 62, name: "SAFETY MANAGER" },
  { id: 63, name: "SCHOOL ADMINISTRATOR" },
  { id: 64, name: "ACCOUNTING MANAGER" },
  { id: 65, name: "FINANCE MANAGER" },
  { id: 66, name: "ACCOUNTS MANAGER" },
  { id: 67, name: "ASSISTANT NATIONAL TREASURER (GOV)" },
  { id: 68, name: "ADMINISTRATION MANAGER" },
  { id: 69, name: "CHIEF ACCOUNTANT" },
  { id: 70, name: "AREA MANAGER (INSURANCE)" },
  { id: 71, name: "AUDIT MANAGER" },
  { id: 72, name: "LOGISTICS MANAGER" },
  { id: 73, name: "ASSISTANT BRANCH MANAGER" },
  { id: 74, name: "UNIT MANAGER" },
  { id: 75, name: "TREASURER" },
  { id: 76, name: "INVENTORY CONTROL MANAGER" },
  { id: 77, name: "ASSISTANT BRANCH HEAD (GOV)" },
  { id: 78, name: "DEPARTMENT HEAD" },
  { id: 79, name: "TRAINING MANAGER" },
  { id: 80, name: "ASSISTANT TRAINING MANAGER" },
  { id: 81, name: "CUSTOMER SERVICE MANAGER" },
  { id: 82, name: "FRONT OFFICE MANAGER" },
  { id: 83, name: "MARKETING MANAGER" },
  { id: 84, name: "SALES MANAGER" },
  { id: 85, name: "STOCKROOM MANAGER" },
  { id: 86, name: "STORE MANAGER" },
  { id: 87, name: "ASSISTANT STORE MANAGER" },
  { id: 88, name: "ASSISTANT SALES MANAGER" },
  { id: 89, name: "SALES AND MARKETING MANAGER" },
  { id: 90, name: "ADVERTISING MANAGER" },
  { id: 91, name: "PROMOTIONS DEPARTMENT MANAGER" },
  { id: 92, name: "PUBLIC RELATIONS MANAGER" },
  { id: 93, name: "ADS & PROMO ASSISTANT MANAGER" },
  { id: 94, name: "ART DIRECTOR" },
  { id: 95, name: "ASSISTANT ART DIRECTOR" },
  { id: 96, name: "LAYOUT DIRECTOR" },
  { id: 97, name: "DEPARTMENT MANAGER" },
  { id: 98, name: "DISTRIBUTION MANAGER" },
  { id: 99, name: "PURCHASING MANAGER" },
  { id: 100, name: "SUPPLY MANAGER" },
  { id: 101, name: "MATERIAL RESOURCES MANAGER" },
  { id: 102, name: "INFORMATION TECHNOLOGY MANAGER" },
  { id: 103, name: "SYSTEMS ADMINISTRATOR" },
  { id: 104, name: "INFORMATION AND COMMUNICATION TECHNOLOGY MANAGER" },
  { id: 105, name: "RESEARCH AND DEVELOPMENT MANAGER" },
  { id: 106, name: "RESEARCH AND DEVELOPMENT ASSISTANT" },
  { id: 107, name: "EQUIPMENT MANAGER" },
  { id: 108, name: "HANDICRAFT SHOP MANAGER" },
  { id: 109, name: "BUSINESS DEVELOPMENT MANAGER" },
  { id: 110, name: "ENGINEERING MANAGER" },
  { id: 111, name: "SERVICE MANAGER" },
  { id: 112, name: "MANUFACTURING GENERAL MANAGER" },
  { id: 113, name: "CONSTRUCTION CONTRACTOR" },
  { id: 114, name: "CONSTRUCTION GENERAL MANAGER" },
  { id: 115, name: "RETAIL TRADE GENERAL MANAGER" },
  { id: 116, name: "RETAIL TRADE PROPRIETOR" },
  { id: 118, name: "HOTEL GENERAL MANAGER" },
  { id: 119, name: "GUEST HOUSE PROPRIETOR" },
  { id: 120, name: "HOTEL PROPRIETOR" },
  { id: 121, name: "LODGING PROPRIETOR" },
  { id: 122, name: "AREA OPERATIONS MANAGER" },
  { id: 123, name: "COMMUNICATIONS GENERAL MANAGER" },
  { id: 124, name: "BUSINESS SERVICES GENERAL MANAGER" },
  { id: 125, name: "BUSINESS SERVICES MANAGING PROPRIETOR" },
  { id: 126, name: "ASSISTANT INDUSTRIAL ZONE MANAGER (GOV)" },
  { id: 127, name: "ASSISTANT GENERAL MANAGER" },
  { id: 128, name: "SPECIALTY STORE MANAGING PROPRIETOR" },
  { id: 129, name: "OFFICE ADMINISTRATOR" },
  { id: 130, name: "MASSAGE PARLOR GENERAL MANAGER" },
  { id: 131, name: "PERSONAL CARE SERVICES GENERAL MANAGER" },
  { id: 132, name: "PERSONAL CARE SERVICES MANAGING PROPRIETOR" },
  { id: 133, name: "HOUSEKEEPING MANAGER" },
  { id: 134, name: "PRINCIPAL" },
  { id: 135, name: "SCHOOL PRINCIPAL" },
  { id: 136, name: "HEAD TEACHER" },
  { id: 137, name: "CHIEF AIRCRAFT MAINTENANCE OFFICER (GOV)" },
  { id: 138, name: "SHIPPING SUPERVISOR" },
  { id: 139, name: "INFORMATION TECHNOLOGY OFFICER (GOV)" },
  { id: 140, name: "BUSINESS ANALYST" },
  { id: 141, name: "DATABASE ADMINISTRATOR" },
  { id: 142, name: "INFORMATION AND COMMUNICATION TECHNOLOGY SUPERVISOR" },
  { id: 143, name: "COMMUNICATION SERVICE SUPERVISOR" },
  { id: 144, name: "PROVINCIAL INFORMATION OFFICER (GOV)" },
  { id: 145, name: "MUNICIPAL INFORMATION OFFICER (GOV)" },
  { id: 146, name: "PUBLIC RELATIONS SUPERVISOR" },
  { id: 147, name: "PLANT MAINTENANCE SUPERVISOR" },
  { id: 148, name: "MAINTENANCE SUPERVISOR" },
  { id: 149, name: "PRODUCT DEVELOPMENT OFFICER" },
  { id: 150, name: "PRODUCTION SUPERVISOR" },
  { id: 151, name: "REPAIR AND MAINTENANCE SECTION HEAD" },
  { id: 152, name: "QUALITY ASSURANCE SUPERVISOR" },
  { id: 153, name: "GENERAL FOREMAN" },
  { id: 154, name: "CONSTRUCTION FOREMAN" },
  { id: 155, name: "MECHANICAL FOREMAN" },
  { id: 156, name: "ENGINEERING AND MAINTENANCE SUPERVISOR" },
  { id: 157, name: "BUILDING ADMINISTRATOR" },
  { id: 158, name: "PRODUCTION ENGINEERING SUPERVISOR" },
  { id: 159, name: "HOUSEKEEPING SUPERVISOR" },
  { id: 160, name: "JANITORIAL SUPERVISOR" },
  { id: 161, name: "SERVICE SUPERVISOR" },
  { id: 162, name: "CARPENTER FOREMAN (GOV)" },
  { id: 163, name: "CONSTRUCTION AND MAINTENANCE FOREMAN (GOV)" },
  { id: 164, name: "FACILITIES FOREMAN (GOV)" },
  { id: 165, name: "FARM FOREMAN (GOV)" },
  { id: 166, name: "LABOR FOREMAN (GOV)" },
  { id: 167, name: "MAINTENANCE GENERAL FOREMAN (GOV)" },
  { id: 168, name: "MECHANICAL FOREMAN (GOV)" },
  { id: 169, name: "UTILITY FOREMAN (GOV)" },
  { id: 170, name: "SALES SUPERVISOR (RETAIL TRADE)" },
  { id: 171, name: "PURCHASING SUPERVISOR" },
  { id: 172, name: "SALES INSPECTOR" },
  { id: 173, name: "SALES SUPERVISOR" },
  { id: 174, name: "SALES WORKER SUPERVISOR" },
  { id: 175, name: "SALES AND PROMOTION SUPERVISOR V (GOV)" },
  { id: 176, name: "SALES OFFICER" },
  { id: 177, name: "MARKETING SUPERVISOR" },
  { id: 178, name: "STORE SUPERVISOR" },
  { id: 179, name: "ASSISTANT STORE SUPERVISOR" },
  { id: 180, name: "PUBLIC RELATIONS COORDINATOR" },
  { id: 181, name: "HOTEL SUPERVISOR" },
  { id: 182, name: "RESORT SUPERVISOR" },
  { id: 183, name: "CITY GOVERNMENT ASSISTANT DEPARTMENT HEAD I (GOV)" },
  { id: 184, name: "CORPORATE PLANNING CHIEF" },
  { id: 185, name: "DATA MANAGEMENT CHIEF (GOV)" },
  { id: 186, name: "HEAD CIVIL SERVICE FIELD OFFICER (GOV)" },
  { id: 187, name: "HOTEL/RESORT MAINTENANCE SUPERVISOR (GOV)" },
  { id: 188, name: "MATERIAL PLANNING SERVICES CHIEF (GOV)" },
  { id: 189, name: "ADMINISTRATIVE OFFICER V (GOV)" },
  { id: 190, name: "WAREHOUSE/SHIPPING SERVICES CHIEF (GOV)" },
  { id: 191, name: "ADMINISTRATIVE SUPERVISOR" },
  { id: 192, name: "PERSONNEL SUPERVISOR" },
  { id: 193, name: "INVENTORY SUPERVISOR" },
  { id: 194, name: "TRAINING OFFICER" },
  { id: 195, name: "CHIEF ENGINEER" },
  { id: 196, name: "ASSISTANT CHIEF ENGINEER" },
  { id: 197, name: "HUMAN RESOURCE SUPERVISOR" },
  { id: 198, name: "TRAINING SUPERVISOR" },
  { id: 199, name: "PROJECT SUPERVISOR" },
  { id: 200, name: "HUMAN RESOURCE DEVELOPMENT MANAGER" },
  { id: 201, name: "OPERATIONS SUPERVISOR" },
  { id: 202, name: "MINING OPERATIONS OFFICER (GOV)" },
  { id: 203, name: "FARM SUPERVISOR" },
  { id: 204, name: "ARCHITECTURAL ENGINEERING SUPERVISOR" },
  { id: 205, name: "CHIEF VETERANS ASSISTANCE OFFICER (GOV)" },
  { id: 206, name: "MEDICAL SPECIALIST" },
  { id: 207, name: "MUNICIPAL HEALTH OFFICER I (GOV)" },
  { id: 208, name: "MUNICIPAL SOCIAL WELFARE AND DEVELOPMENT OFFICER (GOV)" },
  { id: 209, name: "HEAD NURSE" },
  { id: 210, name: "ASSISTANT HEAD NURSE" },
  { id: 211, name: "CHIEF SECURITY OFFICER" },
  { id: 212, name: "ASSISTANT CHIEF SECURITY OFFICER" },
  { id: 213, name: "SAFETY SUPERVISOR" },
  { id: 214, name: "CHIEF MEDICAL TECHNOLOGIST" },
  { id: 215, name: "CHIEF PHARMACIST" },
  { id: 216, name: "CITY ENGINEER I (GOV)" },
  { id: 217, name: "ACCOUNTING SUPERVISOR" },
  { id: 218, name: "ACCOUNTS OFFICER" },
  { id: 219, name: "ACTUARIAL ASSOCIATE" },
  { id: 220, name: "CHIEF CORPORATE ACCOUNTANT A (GOV)" },
  { id: 221, name: "CHIEF MARKETING SPECIALIST (GOV)" },
  { id: 222, name: "CORPORATE FINANCE SERVICES CHIEF (GOV)" },
  { id: 223, name: "BANK SUPERVISOR" },
  { id: 224, name: "LOGISTICS SUPERVISOR" },
  { id: 225, name: "LOANS MANAGER" },
  { id: 226, name: "COST ACCOUNTING SUPERVISOR" },
  { id: 227, name: "FINANCIAL CONSULTANT" },
  { id: 228, name: "CHIEF TRADING SPECIALIST" },
  { id: 229, name: "CORPORATE LEGAL COUNSEL (GOV)" },
  { id: 230, name: "CHIEF LABOR AND EMPLOYMENT OFFICER (GOV)" },
  { id: 231, name: "TEACHERS' CAMP SUPERINTENDENT (GOV)" },
  { id: 232, name: "OTHER SUPERVISOR NOT ELSEWHERE CLASSIFIED" },
  { id: 233, name: "SOUND PHYSICIST" },
  { id: 234, name: "FORENSIC CHEMIST" },
  { id: 235, name: "CHEMIST (GENERAL)" },
  { id: 236, name: "QUALITY CONTROL CHEMIST" },
  { id: 237, name: "QUALITY ASSURANCE HEAD" },
  { id: 238, name: "GEOLOGIST" },
  { id: 239, name: "HYDROGRAPHER (GOV)" },
  { id: 240, name: "SOFTWARE DESIGNER" },
  { id: 241, name: "COMPUTER SYSTEMS ENGINEER" },
  { id: 242, name: "SYSTEMS ANALYST" },
  { id: 243, name: "WEB DESIGNER" },
  { id: 244, name: "INFORMATION TECHNOLOGY (IT) SPECIALIST" },
  { id: 245, name: "INFORMATION TECHNOLOGY OFFICER I (GOV)" },
  { id: 246, name: "WEB DEVELOPER" },
  { id: 247, name: "SYSTEMS DEVELOPER (COMPUTER)" },
  { id: 248, name: "INFORMATION TECHNOLOGY OFFICER" },
  { id: 249, name: "NETWORK ENGINEER" },
  { id: 250, name: "COMPUTER GRAPHICS ARTIST" },
  { id: 251, name: "OPERATIONS ANALYST" },
  { id: 252, name: "COMPUTER PROGRAMMER" },
  { id: 253, name: "DATABASE PROGRAMMER" },
  { id: 254, name: "COMPUTER PROGRAMMER I (GOV)" },
  { id: 255, name: "COMPUTER PROGRAMMER II (GOV)" },
  { id: 256, name: "PROGRAMMER I (GOV)" },
  { id: 257, name: "JAVA PROGRAMMER" },
  { id: 258, name: "COMPUTER APPLICATIONS ENGINEER" },
  { id: 259, name: "COMPUTER MAINTENANCE TECHNOLOGIST I (GOV)" },
  { id: 260, name: "ARCHITECT" },
  { id: 261, name: "BUILDING ARCHITECT" },
  { id: 262, name: "LANDSCAPE ARCHITECT" },
  { id: 263, name: "ARCHITECT (GOV)" },
  { id: 264, name: "ARCHITECTURAL ENGINEER" },
  { id: 265, name: "ASSOCIATE ARCHITECT (GOV)" },
  { id: 266, name: "BIOMEDICAL ENGINEER" },
  { id: 267, name: "BUILDING CONSTRUCTION ENGINEER" },
  { id: 268, name: "CIVIL ENGINEER (GENERAL)" },
  { id: 269, name: "PUBLIC HEALTH ENGINEER" },
  { id: 270, name: "SANITARY ENGINEER" },
  { id: 271, name: "STRUCTURAL ENGINEER" },
  { id: 272, name: "ESTIMATOR" },
  { id: 273, name: "COST ENGINEER" },
  { id: 274, name: "CADET ENGINEER (CIVIL)" },
  { id: 275, name: "SITE ENGINEER" },
  { id: 276, name: "JR. SITE ENGINEER" },
  { id: 277, name: "ELECTRICAL ENGINEER (GENERAL)" },
  { id: 278, name: "MASTER ELECTRICIAN" },
  { id: 279, name: "ELECTROMECHANICAL EQUIPMENT ENGINEER" },
  { id: 280, name: "CADET ENGINEER (ELECTRICAL)" },
  { id: 281, name: "ELECTRONICS ENGINEER (GENERAL)" },
  { id: 282, name: "COMPUTER ENGINEER" },
  { id: 283, name: "TELECOMMUNICATIONS ENGINEER" },
  { id: 284, name: "ELECTRONICS ENGINEERING TECHNOLOGIST" },
  { id: 285, name: "CADET ENGINEER (ELECTRONICS AND COMMUNICATIONS)" },
  { id: 286, name: "ELECTRONICS AND COMMUNICATIONS ENGINEER" },
  { id: 287, name: "COMMUNICATIONS ENGINEER" },
  { id: 288, name: "SYSTEMS ENGINEER" },
  { id: 289, name: "CADET ENGINEER (INSTRUMENTATION & CONTROL)" },
  { id: 290, name: "INSTRUMENTATION & CONTROL ENGINEER" },
  { id: 291, name: "CADET ENGINEER (RADIO AND ELECTRONICS)" },
  { id: 292, name: "TELECOMMUNICATION SPECIALIST" },
  { id: 293, name: "TELECOMMUNICATOR" },
  { id: 294, name: "AERONAUTICAL ENGINEER" },
  { id: 295, name: "AGRICULTURAL ENGINEER" },
  { id: 296, name: "AUTOMOTIVE ENGINEER" },
  { id: 297, name: "MARINE ENGINEER" },
  { id: 298, name: "MECHANICAL ENGINEER (GENERAL)" },
  { id: 299, name: "CADET ENGINEER (MECHANICAL)" },
  { id: 300, name: "MAINTENANCE ENGINEER" },
  { id: 301, name: "PETROLEUM & NATURAL GAS ENGINEER (CHEMICAL)" },
  { id: 302, name: "CHEMICAL ENGINEER (GENERAL)" },
  { id: 303, name: "CHEMICAL PROCESS ENGINEER" },
  { id: 304, name: "LABORATORY ANALYST" },
  { id: 305, name: "CADET ENGINEER (CHEMICAL)" },
  { id: 306, name: "TECHNICAL LABORATORY SPECIALIST" },
  { id: 307, name: "MINING ENGINEER (COAL)" },
  { id: 308, name: "MINING ENGINEER (GENERAL)" },
  { id: 309, name: "METALLURGIST" },
  { id: 310, name: "ASSAYER" },
  { id: 311, name: "CARTOGRAPHER" },
  { id: 312, name: "GEODETIC ENGINEER" },
  { id: 313, name: "SURVEYOR (GENERAL)" },
  { id: 314, name: "LAND SURVEYOR" },
  { id: 315, name: "INDUSTRIAL ENGINEER" },
  { id: 316, name: "INDUSTRIAL EFFICIENCY ENGINEER" },
  { id: 317, name: "PRODUCTION ENGINEER" },
  { id: 318, name: "ENGINEER A (GOV)" },
  { id: 319, name: "ENGINEER I (GOV)" },
  { id: 320, name: "ENGINEER II (GOV)" },
  { id: 321, name: "PRODUCTION PLANNER" },
  { id: 322, name: "CADET ENGINEER (INDUSTRIAL)" },
  { id: 323, name: "PRODUCT PLANNER" },
  { id: 324, name: "QUALITY CONTROL HEAD" },
  { id: 325, name: "QUANTITY SURVEYOR" },
  { id: 326, name: "EQUIPMENT CONTROL ENGINEER" },
  { id: 327, name: "PLANT ENGINEER" },
  { id: 328, name: "PROCESS ENGINEER" },
  { id: 329, name: "BIOLOGIST (GENERAL)" },
  { id: 330, name: "ECOLOGIST" },
  { id: 331, name: "ZOOLOGIST (GENERAL)" },
  { id: 332, name: "PATHOLOGIST" },
  { id: 333, name: "FARMING ADVISER" },
  { id: 334, name: "HORTICULTURIST" },
  { id: 335, name: "FORESTER" },
  { id: 336, name: "ANAESTHETIST" },
  { id: 337, name: "CARDIOLOGIST" },
  { id: 338, name: "DERMATOLOGIST" },
  { id: 339, name: "MEDICAL DOCTOR" },
  { id: 340, name: "NEUROSURGEON" },
  { id: 341, name: "OPTHALMOLOGIST" },
  { id: 342, name: "PEDIATRICIAN" },
  { id: 343, name: "PHYSICIAN" },
  { id: 344, name: "PSYCHIATRIST" },
  { id: 345, name: "SURGEON (GENERAL)" },
  { id: 346, name: "CITY HEALTH OFFICER I (GOV)" },
  { id: 347, name: "DENTIST (GENERAL)" },
  { id: 348, name: "DENTIST I (C) (GOV)" },
  { id: 349, name: "VETERINARIAN (GENERAL)" },
  { id: 350, name: "MEAT CONTROL OFFICER I (GOV)" },
  { id: 351, name: "PHARMACIST (GENERAL)" },
  { id: 352, name: "INDUSTRIAL PHARMACIST" },
  { id: 353, name: "PHARMACY ADVISER (GOV)" },
  { id: 354, name: "PHARMACY PROGRAM SUPERVISOR (GOV)" },
  { id: 355, name: "ASSISTANT PHARMACIST" },
  { id: 356, name: "OPTICIAN (GENERAL)" },
  { id: 357, name: "DISPENSING OPTICIAN" },
  { id: 358, name: "OPTOMETRIST" },
  { id: 359, name: "MEDICAL TECHNOLOGIST" },
  { id: 360, name: "NUCLEAR MEDICAL TECHNOLOGIST" },
  { id: 361, name: "RADIOLOGIC TECHNOLOGIST" },
  { id: 362, name: "MEDICAL TECHNOLOGIST II (GOV)" },
  { id: 363, name: "BIOMEDICAL TECHNOLOGIST" },
  { id: 364, name: "ACUPUNCTURIST" },
  { id: 365, name: "CHIROPRACTOR" },
  { id: 366, name: "OCCUPATIONAL THERAPIST" },
  { id: 367, name: "PHYSICAL THERAPIST" },
  { id: 368, name: "PHYSICAL THERAPIST (GOV)" },
  { id: 369, name: "SPEECH THERAPIST (GOV)" },
  { id: 370, name: "RESPIRATORY THERAPIST" },
  { id: 371, name: "PHLEBOTOMIST" },
  { id: 372, name: "PROFESSIONAL NURSE (GENERAL)" },
  { id: 373, name: "CONSULTANT NURSE" },
  { id: 374, name: "OCCUPATIONAL HEALTH NURSE" },
  { id: 375, name: "PRIVATE NURSE" },
  { id: 376, name: "PUBLIC HEALTH NURSE" },
  { id: 377, name: "SCHOOL NURSE" },
  { id: 378, name: "INDUSTRIAL NURSE" },
  { id: 379, name: "ANAESTHETIC NURSE" },
  { id: 380, name: "CARDIAC HOLDING UNIT NURSE" },
  { id: 381, name: "STAFF NURSE" },
  { id: 382, name: "CLINIC NURSE" },
  { id: 383, name: "PEDIATRIC WARD NURSE" },
  { id: 384, name: "OPERATING ROOM NURSE" },
  { id: 385, name: "EMERGENCY ROOM NURSE" },
  { id: 386, name: "COMPANY NURSE" },
  { id: 387, name: "OB-GYNE NURSE" },
  { id: 388, name: "DIALYSIS NURSE" },
  { id: 389, name: "OPTHALMOLOGY NURSE" },
  { id: 390, name: "CARDIAC SURGICAL NURSE" },
  { id: 391, name: "CARDIOVASCULAR TELEMETRY NURSE" },
  { id: 392, name: "DELIVERY ROOM NURSE" },
  { id: 393, name: "DENTAL NURSE" },
  { id: 394, name: "DERMATOLOGICAL WARD NURSE" },
  { id: 395, name: "HEMODIALYSIS NURSE" },
  { id: 396, name: "HOME HEALTH CARE NURSE" },
  { id: 397, name: "MEDICAL WARD NURSE" },
  { id: 398, name: "NEUROLOGY/NEUROSURGEON NURSE" },
  { id: 399, name: "PSYCHIATRIC WARD NURSE" },
  { id: 400, name: "RENAL TRANSPLANT NURSE" },
  { id: 401, name: "COLLEGE AND UNIVERSITY PROFESSOR" },
  { id: 402, name: "ADVANCED NURSING TEACHER" },
  { id: 403, name: "ECONOMICS AND COMMERCE TEACHER (TERTIARY EDUCATION)" },
  { id: 404, name: "EDUCATION TEACHER (TERTIARY EDUCATION)" },
  {
    id: 405,
    name: "ENGINEERING AND ARCHITECTURE TEACHER (TERTIARY EDUCATION)",
  },
  { id: 406, name: "TEACHER (HISTORY, PHILOSOPHY, SOCIOLOGY)" },
  { id: 407, name: "LANGUAGES AND LITERATURE TEACHER (TERTIARY EDUCATION)" },
  { id: 408, name: "LIFE AND MEDICAL SCIENCES TEACHER (TERTIARY EDUCATION)" },
  { id: 409, name: "MATHEMATICS TEACHER (TERTIARY EDUCATION)" },
  { id: 410, name: "MEDICAL THERAPY TEACHER" },
  { id: 411, name: "PHYSICAL SCIENCES TEACHER (TERTIARY EDUCATION)" },
  { id: 412, name: "SOCIAL SCIENCES TEACHER" },
  { id: 413, name: "PROFESSOR I (GOV)" },
  { id: 414, name: "CLINICAL INSTRUCTOR" },
  { id: 415, name: "FINE ARTS TEACHER (TERTIARY)" },
  { id: 416, name: "TRADES TEACHER" },
  { id: 417, name: "SOFTWARE INSTRUCTOR" },
  { id: 418, name: "COMPUTER INSTRUCTOR" },
  { id: 419, name: "GENERAL SECONDARY EDUCATION TEACHING PROFESSIONAL" },
  { id: 420, name: "LANGUAGE TEACHER (SECONDARY EDUCATION)" },
  { id: 421, name: "LITERATURE TEACHER (SECONDARY EDUCATION)" },
  { id: 422, name: "READING AND WRITING TEACHER (SECONDARY EDUCATION)" },
  { id: 423, name: "SOCIAL STUDIES TEACHER (SECONDARY EDUCATION)" },
  { id: 424, name: "SPECIAL EDUCATION TEACHER I (SECONDARY GRADES) (GOV)" },
  { id: 425, name: "FILIPINO TEACHER (SECONDARY EDUCATION)" },
  { id: 426, name: "TEACHER I (SECONDARY GRADES) (GOV)" },
  { id: 427, name: "TEACHER II (SECONDARY GRADES) (GOV)" },
  { id: 428, name: "TEACHER III (SECONDARY GRADES) (GOV)" },
  { id: 429, name: "COMPUTER TEACHER (SECONDARY EDUCATION)" },
  { id: 430, name: "MUSIC ARTS AND P.E. TEACHER (SECONDARY EDUCATION)" },
  { id: 431, name: "TEACHER (SECONDARY EDUCATION)" },
  { id: 432, name: "SPECIAL EDUCATION TEACHER" },
  { id: 433, name: "MATHEMATICS TEACHER (SECONDARY EDUCATION)" },
  { id: 434, name: "NATURAL SCIENCE TEACHER (SECONDARY EDUCATION)" },
  { id: 435, name: "SPECIAL SCIENCE TEACHER I (SECONDARY GRADES)(GOV)" },
  { id: 436, name: "SPECIAL SCIENCE TEACHER II (SECONDARY GRADES)(GOV)" },
  { id: 437, name: "BIOLOGY TEACHER (SECONDARY EDUCATION)" },
  { id: 438, name: "CHEMISTRY TEACHER (SECONDARY EDUCATION)" },
  { id: 439, name: "PHYSICS TEACHER (SECONDARY EDUCATION)" },
  { id: 440, name: "AGRICULTURAL SCIENCE TEACHER (SECONDARY EDUCATION)" },
  { id: 441, name: "DOMESTIC SCIENCE TEACHER (SECONDARY EDUCATION)" },
  { id: 442, name: "TECHNICAL EDUCATION TEACHER (SECONDARY EDUCATION)" },
  { id: 443, name: "VOCATIONAL EDUCATION TEACHER (SECONDARY EDUCATION)" },
  { id: 444, name: "VOCATIONAL/TECHNICAL TRAINOR" },
  { id: 445, name: "VOCATIONAL EDUCATION TEACHING PROFESSIONAL" },
  {
    id: 446,
    name: "HEAD TEACHER VI (VOCATIONAL AND TWO YEARS TECHNICAL) (GOV)",
  },
  {
    id: 447,
    name: "SPECIAL SCIENCE TEACHER I (VOCATIONAL & TWO YRS. TECHNICAL COURSE) (GOV)",
  },
  {
    id: 448,
    name: "SPECIAL SCIENCE TEACHER III (VOCATIONAL & TWO YRS. TECHNICAL COURSE) (GOV)",
  },
  {
    id: 449,
    name: "TEACHER I (VOCATIONAL & TWO YEARS TECHNICAL COURSE) (GOV)",
  },
  { id: 450, name: "HOME ECONOMICS TEACHER (SECONDARY EDUCATION)" },
  { id: 451, name: "GENERAL ELEMENTARY EDUCATION TEACHING PROFESSIONAL" },
  { id: 452, name: "LANGUAGE TRAINOR (PRIMARY EDUCATION)" },
  { id: 453, name: "FILIPINO TEACHER (ELEMENTARY EDUCATION)" },
  { id: 454, name: "TEACHER I (ELEMENTARY GRADES) (GOV)" },
  { id: 455, name: "TEACHER III (ELEMENTARY GRADES) (GOV)" },
  { id: 456, name: "COMPUTER TRAINOR (ELEMENTARY EDUCATION)" },
  { id: 457, name: "TEACHER (ELEMENTARY MATHEMATICS)" },
  { id: 458, name: "TEACHER (ELEMENTARY SCIENCE)" },
  { id: 459, name: "TEACHER (ELEMENTARY SCHOOL)" },
  { id: 460, name: "KINDERGARTEN TEACHER" },
  { id: 461, name: "NURSERY SCHOOL TEACHER" },
  { id: 462, name: "PREPARATORY SCHOOL TEACHER" },
  { id: 463, name: "SPECIAL EDUCATION TEACHER I (PRE-SCHOOL) (GOV)" },
  { id: 464, name: "TEACHER I (PRE-SCHOOL) (GOV)" },
  { id: 465, name: "ADULT LITERACY TEACHER" },
  { id: 466, name: "NON-FORMAL EDUCATION TEACHER" },
  { id: 467, name: "INSTRUCTOR" },
  { id: 468, name: "ASSISTANT INSTRUCTOR" },
  { id: 469, name: "COLLEGE INSTRUCTOR" },
  { id: 470, name: "LECTURER" },
  { id: 471, name: "FACILITATOR" },
  { id: 472, name: "EDUCATION METHODS ADVISER" },
  { id: 473, name: "TEACHING AIDE SPECIALIST" },
  { id: 474, name: "PROFESSIONAL TUTOR" },
  { id: 475, name: "COST ACCOUNTANT" },
  { id: 476, name: "ACCOUNTANT (GENERAL)" },
  { id: 477, name: "AUDITOR" },
  { id: 478, name: "FINANCIAL ANALYST" },
  { id: 479, name: "ACCOUNTANT I (GOV)" },
  { id: 480, name: "ACCOUNTANT III (GOV)" },
  { id: 481, name: "ACCOUNTING SPECIALIST I (GOV)" },
  { id: 482, name: "ACCOUNT ANALYST (GOV)" },
  { id: 483, name: "ACCOUNTS MANAGEMENT ANALYST I (GOV)" },
  { id: 484, name: "ACCOUNTING ANALYST (GOV)" },
  { id: 485, name: "SENIOR ACCOUNTANT" },
  { id: 486, name: "SUPERVISING ACCOUNTING SPECIALIST (GOV)" },
  { id: 487, name: "ASSOCIATE ACCOUNTANT" },
  { id: 488, name: "ACCOUNT ANALYST" },
  { id: 489, name: "ACCOUNTING ANALYST" },
  { id: 490, name: "SEC GENERAL ACCOUNTANT (GOV)" },
  { id: 491, name: "INTERNAL AUDITOR" },
  { id: 492, name: "EXTERNAL AUDITOR" },
  { id: 493, name: "GUIDANCE COUNSELLOR" },
  { id: 494, name: "HUMAN RESOURCE DEVELOPMENT SPECIALIST" },
  { id: 495, name: "PERSONNEL SPECIALIST" },
  { id: 496, name: "GUIDANCE SERVICES ASSOCIATE I (GOV)" },
  { id: 497, name: "HUMAN RESOURCE MANAGEMENT OFFICER" },
  { id: 498, name: "PERSONNEL ASSISTANT" },
  { id: 499, name: "HUMAN RESOURCE DEVELOPMENT OFFICER" },
  { id: 500, name: "OPERATIONS OFFICER" },
  { id: 501, name: "GUIDANCE COUNSELOR (COLLEGE)" },
  { id: 502, name: "PERSONNEL OFFICER" },
  { id: 503, name: "EXAMINER" },
  { id: 504, name: "SENIOR CURRENCY/SECURITIES OPERATIONS OFFICER (GOV)" },
  { id: 505, name: "SUPERVISING FIELD OPERATIONS SPECIALIST (GOV)" },
  { id: 506, name: "BANK OFFICER" },
  { id: 507, name: "BANK TRADER" },
  { id: 508, name: "COLLECTION SUPERVISOR" },
  { id: 509, name: "HOME ECONOMIST" },
  { id: 510, name: "MARKET RESEARCH ANALYST" },
  { id: 511, name: "PUBLIC RELATIONS OFFICER" },
  { id: 512, name: "BUSINESS DEVELOPMENT/MARKETING ANALYST (GOV)" },
  { id: 513, name: "BUSINESS DEVELOPMENT/MARKETING ASSISTANT (GOV)" },
  { id: 514, name: "MARKET DEVELOPMENT SPECIALIST" },
  {
    id: 515,
    name: "BUSINESS DEVELOPMENT/MARKETING OFFICER A (IUG- SG-16)(GOV)",
  },
  { id: 516, name: "MARKETING OFFICER" },
  { id: 517, name: "MARKETING STAFF" },
  { id: 518, name: "JR. SUPERVISOR (MANAGEMENT TRAINEE)" },
  { id: 519, name: "ACCOUNTS EXECUTIVE" },
  { id: 520, name: "MERCHANDISING SUPERVISOR" },
  { id: 521, name: "SALES EXECUTIVE" },
  { id: 522, name: "SALES AND PROMOTION SUPERVISOR" },
  { id: 523, name: "BUSINESS DEVELOPMENT OFFICER" },
  { id: 524, name: "ACCOUNTS COORDINATOR" },
  { id: 525, name: "MARKETING COORDINATOR" },
  { id: 526, name: "TELEMARKETER" },
  { id: 527, name: "ADVERTISING CONSULTANT" },
  { id: 528, name: "ADVERTISING ASSISTANT" },
  { id: 529, name: "ADVERTISING OFFICER" },
  { id: 530, name: "BUSINESS DEVELOPMENT/MARKETING SPECIALIST" },
  { id: 531, name: "MARKETING EXECUTIVE" },
  { id: 532, name: "PURCHASING OFFICER" },
  { id: 533, name: "ATTORNEY" },
  { id: 534, name: "LAWYER" },
  { id: 535, name: "ASSISTANT GOVERNMENT CORPORATE COUNSEL" },
  { id: 536, name: "ASSOCIATE PUBLIC ATTORNEY I (GOV)" },
  { id: 537, name: "ATTORNEY I (GOV)" },
  { id: 538, name: "ATTORNEY III (GOV)" },
  { id: 539, name: "ATTORNEY IV (GOV)" },
  { id: 540, name: "CITY LEGAL OFFICER I (GOV)" },
  { id: 541, name: "COURT ATTORNEY I (GOV)" },
  { id: 542, name: "PROSECUTION ATTORNEY I (GOV)" },
  { id: 543, name: "COURT ADMINISTRATOR" },
  { id: 544, name: "LEGAL OFFICER (GOV)" },
  { id: 545, name: "LEGAL RESEARCHER (GOV)" },
  { id: 546, name: "LEGAL RESEARCHER" },
  { id: 547, name: "LEGAL OFFICER" },
  { id: 548, name: "ART GALLERY AND MUSEUM CURATOR" },
  { id: 549, name: "COMPUTER LIBRARIAN" },
  { id: 550, name: "LIBRARIAN" },
  { id: 551, name: "ECONOMIST (GENERAL)" },
  { id: 552, name: "ANTHROPOLOGIST" },
  { id: 553, name: "POLITICAL SCIENTIST" },
  { id: 554, name: "POLITICAL ANALYST" },
  { id: 555, name: "SPEECH TRANSCRIBER (GOV)" },
  { id: 556, name: "TRANSCRIBER" },
  { id: 557, name: "PSYCHOLOGIST" },
  { id: 558, name: "PSYCHOLOGIST (GOV)" },
  { id: 559, name: "PSYCHOMETRICIAN" },
  { id: 560, name: "FAMILY CASEWORKER" },
  { id: 561, name: "SOCIAL WORKER (GENERAL)" },
  { id: 562, name: "SOCIAL WELFARE OFFICER" },
  { id: 563, name: "PROFESSIONAL SOCIAL WORKER" },
  { id: 564, name: "COMMUNITY AFFAIRS OFFICER I (GOV)" },
  { id: 565, name: "SOCIAL WELFARE OFFICER (GOV)" },
  { id: 566, name: "VOLUNTEER SERVICE OFFICER (GOV)" },
  { id: 567, name: "COMMUNITY RELATIONS OFFICER" },
  { id: 568, name: "COMMUNITY DEVELOPMENT WORKER" },
  { id: 569, name: "PROGRAM ORGANIZER" },
  { id: 570, name: "COMMUNITY DEVELOPMENT OFFICER" },
  { id: 571, name: "PROJECT DEVELOPMENT OFFICER" },
  { id: 572, name: "AUTHOR" },
  { id: 573, name: "BOOK EDITOR" },
  { id: 574, name: "EDITOR" },
  { id: 575, name: "JOURNALIST" },
  { id: 576, name: "REPORTER" },
  { id: 577, name: "TECHNICAL WRITER" },
  { id: 578, name: "ASSISTANT TO THE EDITOR (GOV)" },
  { id: 579, name: "CITY INFORMATION OFFICER I (GOV)" },
  { id: 580, name: "EDITOR (GOV)" },
  { id: 581, name: "SCRIPTWRITER I (GOV)" },
  { id: 582, name: "SCRIPTWRITER II (GOV)" },
  { id: 583, name: "SENIOR NEWS EDITOR (GOV)" },
  { id: 584, name: "SPEECHWRITER (GOV)" },
  { id: 585, name: "STAFF WRITER (GOV)" },
  { id: 586, name: "MESSAGE WRITER (GOV)" },
  { id: 587, name: "TEXTBOOK EDITOR (GOV)" },
  { id: 588, name: "LITERARY WRITER" },
  { id: 589, name: "CREATIVE WRITER" },
  { id: 590, name: "COPY EDITOR" },
  { id: 591, name: "EDITORIAL STAFF" },
  { id: 592, name: "FREELANCE WRITER" },
  { id: 593, name: "COPY WRITER" },
  { id: 594, name: "ASSISTANT EDITOR" },
  { id: 595, name: "SCRIPTWRITER" },
  { id: 596, name: "STAFF WRITER" },
  { id: 597, name: "COMMERCIAL ARTIST" },
  { id: 598, name: "ARTISTIC PAINTER" },
  { id: 599, name: "GRAPHIC ARTIST" },
  { id: 600, name: "ANIMATOR" },
  { id: 601, name: "GRAPHIC DESIGNER" },
  { id: 602, name: "RECORDING ARTIST" },
  { id: 603, name: "MUSIC COMPOSER" },
  { id: 604, name: "CONCERT SINGER" },
  { id: 605, name: "VIOLINIST" },
  { id: 606, name: "INSTRUMENT TECHNICIAN" },
  { id: 607, name: "MUSICIAN" },
  { id: 608, name: "CHOREOGRAPHER" },
  { id: 609, name: "ACTOR" },
  { id: 610, name: "STAGE DIRECTOR" },
  { id: 611, name: "RADIO AND TELEVISION STORY TELLER" },
  { id: 612, name: "CREATIVE AND PERFORMING ARTIST" },
  { id: 613, name: "RELIGION MINISTER" },
  { id: 614, name: "ASSISTANT PASTOR" },
  { id: 615, name: "ADMINISTRATIVE OFFICER I (GOV)" },
  { id: 616, name: "ADMINISTRATIVE OFFICER III (GOV)" },
  { id: 617, name: "ADMINISTRATIVE OFFICER IV (GOV)" },
  { id: 618, name: "ADMINISTRATIVE SERVICES ASSISTANT I (GOV)" },
  { id: 619, name: "ADMINISTRATIVE SERVICES ASSISTANT II (GOV)" },
  { id: 620, name: "ADMINISTRATIVE SERVICES OFFICER I (GOV)" },
  { id: 621, name: "CORPORATE PLANNING SPECIALIST" },
  { id: 622, name: "OPERATIONS/MAINTENANCE SUPERINTENDENT" },
  { id: 623, name: "PLANNING OFFICER (GOV)" },
  { id: 624, name: "DATA ANALYST-CONTROLLER (GOV)" },
  { id: 625, name: "PROCUREMENT ANALYST (GOV)" },
  { id: 626, name: "PROCUREMENT OFFICER (GOV)" },
  { id: 627, name: "EXECUTIVE ASSISTANT IV (GOV)" },
  { id: 628, name: "PROPERTY OFFICER I (GOV)" },
  { id: 629, name: "PROPERTY/SUPPLY OFFICER A (GOV)" },
  { id: 630, name: "FRONT OFFICE SUPERVISOR (GOV)" },
  { id: 631, name: "REGISTRATION OFFICER I (GOV)" },
  { id: 632, name: "GUESTHOUSE SUPERVISOR" },
  { id: 633, name: "HEAD CASHIER (GOV)" },
  { id: 634, name: "HOME MANAGEMENT SPECIALIST I (GOV)" },
  { id: 635, name: "HOTEL/RESORT OPERATIONS OFFICER A (GOV)" },
  { id: 636, name: "DATA ANALYST" },
  { id: 637, name: "EXECUTIVE ASSISTANT" },
  { id: 638, name: "ADMINISTRATIVE OFFICER" },
  { id: 639, name: "MATERIALS PLANNING OFFICER" },
  { id: 640, name: "GUEST RELATIONS OFFICER" },
  { id: 641, name: "RECORDS OFFICER" },
  { id: 642, name: "PRODUCTION & OPERATIONS SPECIALIST" },
  { id: 643, name: "REGISTRAR" },
  { id: 644, name: "CUSTOMER RELATIONS OFFICER" },
  { id: 645, name: "DOCUMENT ANALYST" },
  { id: 646, name: "ASSISTANT REGISTRAR" },
  { id: 647, name: "PLANNING ANALYST" },
  { id: 648, name: "PROCUREMENT SPECIALIST" },
  { id: 649, name: "LOCAL GOVERNMENT OPERATIONS OFFICER (GOV)" },
  { id: 650, name: "AGRICULTURAL TECHNOLOGIST (GOV)" },
  { id: 651, name: "ENVIRONMENTAL MANAGEMENT RESEARCHER (GOV)" },
  { id: 652, name: "ENVIRONMENTAL ANALYST" },
  { id: 653, name: "ENVIRONMENTAL SPECIALIST" },
  { id: 654, name: "LAND MANAGEMENT EXAMINER (GOV)" },
  { id: 655, name: "WATERSHED FORESTER (GOV)" },
  { id: 656, name: "AGRICULTURIST" },
  { id: 657, name: "POPULATION PROGRAM OFFICER I (GOV)" },
  { id: 658, name: "PUBLIC HEALTH NURSE I (GOV)" },
  { id: 659, name: "HEALTH PROGRAM OFFICER I (GOV)" },
  { id: 660, name: "HOSPITAL ADMINISTRATION SPECIALIST (GOV)" },
  { id: 661, name: "INDUSTRIAL SECURITY GUARD (GOV)" },
  { id: 662, name: "SECURITY OFFICER I (GOV)" },
  { id: 663, name: "LAW ENFORCEMENT EVALUATION OFFICER I (GOV)" },
  { id: 664, name: "MEDICAL OFFICER" },
  { id: 665, name: "NATIONAL SECURITY SPECIALIST (GOV)" },
  { id: 666, name: "NURSE I (GOV)" },
  { id: 667, name: "HEALTH CONSULTANT" },
  { id: 668, name: "SECURITY OFFICER" },
  { id: 669, name: "SAFETY ENGINEER" },
  { id: 670, name: "FIELD OPERATIONS ANALYST I (GOV)" },
  { id: 671, name: "FINANCIAL ANALYST I (GOV)" },
  { id: 672, name: "FINANCIAL AND MANAGEMENT OFFICER I (GOV)" },
  { id: 673, name: "GENERAL INSURANCE SPECIALIST" },
  { id: 674, name: "PROJECT PLANNER" },
  { id: 675, name: "PROGRAM PLANNER" },
  { id: 676, name: "INTERNAL CONTROL OFFICER A (GOV)" },
  { id: 677, name: "LOANS AND CREDIT OFFICER" },
  { id: 678, name: "LOCAL TREASURY EXAMINER I (GOV)" },
  { id: 679, name: "LOCAL TREASURY OPERATIONS OFFICER I (GOV)" },
  { id: 680, name: "MANAGEMENT AND AUDIT ANALYST (GOV)" },
  { id: 681, name: "MARKETING ANALYST A (GOV)" },
  { id: 682, name: "MERCHANT BANKING SPECIALIST (GOV)" },
  { id: 683, name: "SUPERVISING CASHIER (GOV)" },
  { id: 684, name: "TREASURY OPERATIONS ASSISTANT I (GOV)" },
  { id: 685, name: "TREASURY SPECIALIST (GOV)" },
  { id: 686, name: "CREDIT INVESTIGATOR" },
  { id: 687, name: "FINANCE OFFICER" },
  { id: 688, name: "LOGISTICS OFFICER" },
  { id: 689, name: "TREASURY ASSISTANT" },
  { id: 690, name: "LOANS AND CREDIT ANALYST" },
  { id: 691, name: "PROJECT COORDINATOR" },
  { id: 692, name: "RESEARCH AND DEVELOPMENT SPECIALIST" },
  { id: 693, name: "BUDGET ANALYST" },
  { id: 694, name: "TREASURY SUPERVISOR" },
  { id: 695, name: "CREDIT/COLLECTION OFFICER" },
  { id: 696, name: "MARKETING SPECIALIST" },
  { id: 697, name: "MANAGEMENT SPECIALIST" },
  { id: 698, name: "TALENT COORDINATOR" },
  { id: 699, name: "CUSTODIAN" },
  { id: 700, name: "CREDIT/BILLING/COLLECTION OFFICER" },
  { id: 701, name: "FINANCIAL/ACCOUNTS SPECIALIST" },
  { id: 702, name: "OPERATIONS COORDINATOR" },
  { id: 703, name: "MANAGEMENT ANALYST" },
  { id: 704, name: "PROJECT MANAGEMENT OFFICER" },
  { id: 705, name: "INVENTORY CONTROL ANALYST" },
  { id: 706, name: "INVENTORY CONTROL ASSISTANT" },
  { id: 707, name: "DEVELOPMENT MANAGEMENT OFFICER I (GOV)" },
  { id: 708, name: "INVESTMENTS ANALYST (GOV)" },
  { id: 709, name: "MARKET SUPERVISOR I (GOV)" },
  { id: 710, name: "TRADER" },
  { id: 711, name: "INVESTMENT ANALYST" },
  { id: 712, name: "ECONOMIC RESEARCHER" },
  { id: 713, name: "FOREIGN SERVICE OFFICER, CLASS IV (GOV)" },
  { id: 714, name: "ASSISTANT TOURISM COORDINATOR (GOV)" },
  { id: 715, name: "COURT LEGAL RESEARCHER I (GOV)" },
  { id: 716, name: "OVERSEAS OPERATIONS OFFICER II (GOV)" },
  { id: 717, name: "LABOR AND EMPLOYMENT OFFICER I (GOV)" },
  { id: 718, name: "LABOR AND EMPLOYMENT OFFICER II (GOV)" },
  { id: 719, name: "LABOR AND EMPLOYMENT OFFICER III (GOV)" },
  { id: 720, name: "SENIOR LABOR AND EMPLOYMENT OFFICER (GOV)" },
  { id: 721, name: "SUPERVISING LABOR AND EMPLOYMENT OFFICER (GOV)" },
  { id: 722, name: "SCIENCE RESEARCH ANALYST (GOV)" },
  { id: 723, name: "INTERNATIONAL SCIENCE RELATIONS OFFICER I (GOV)" },
  { id: 724, name: "MUSEUM CURATOR (GOV)" },
  {
    id: 725,
    name: "SUPERVISOR OF STUDENT TEACHING (VOCATIONAL & TWO YEARS TECHNICAL COURSE)",
  },
  { id: 726, name: "UNIVERSITY RESEARCHER II (GOV)" },
  { id: 727, name: "TECHNICIAN EDUCATION SPECIALIST I (GOV)" },
  { id: 728, name: "TOURISM OPERATIONS OFFICER I (GOV)" },
  { id: 729, name: "TOURISM COORDINATOR A (GOV)" },
  { id: 730, name: "TOURISM COORDINATOR B (GOV)" },
  { id: 731, name: "UNIVERSITY RESEARCH ASSOCIATE I (GOV)" },
  { id: 732, name: "UNIVERSITY RESEARCH ASSOCIATE II (GOV)" },
  { id: 733, name: "UNIVERSITY RESEARCHER I (GOV)" },
  { id: 734, name: "TOUR CONSULTANT" },
  { id: 735, name: "AIRWAYS COMMUNICATOR I (GOV)" },
  { id: 736, name: "ASSISTANT CHIEF AIRWAYS COMMUNICATOR" },
  { id: 737, name: "INFORMATION OFFICER I (GOV)" },
  { id: 738, name: "INFORMATION TECHNOLOGY CONSULTANT" },
  { id: 739, name: "INFORMATION OFFICER" },
  { id: 740, name: "COMMUNICATION CONSULTANT/SPECIALIST" },
  { id: 741, name: "RESEARCHER" },
  { id: 742, name: "FIELD RESEARCHER" },
  { id: 743, name: "CHEMISTRY TECHNICIAN" },
  { id: 744, name: "PHARMACEUTICAL TECHNICIAN" },
  { id: 745, name: "CLERK OF WORKS" },
  { id: 746, name: "CIVIL ENGINEERING TECHNICIAN (GENERAL)" },
  { id: 747, name: "WATERWORKS TECHNICIAN" },
  { id: 748, name: "ELECTRICAL ENGINEERING TECHNICIAN (GENERAL)" },
  { id: 749, name: "ELECTRICAL ENGINEERING TECHNICIAN (HIGH VOLTAGE)" },
  { id: 750, name: "AIRCONDITIONING TECHNICIAN" },
  { id: 751, name: "ELECTRONICS ENGINEERING TECHNICIAN" },
  { id: 752, name: "BROADCAST TECHNICIAN" },
  {
    id: 753,
    name: "ELECTRONICS AND COMMUNICATIONS EQUIPMENT TECHNICIAN I (GOV)",
  },
  {
    id: 754,
    name: "ELECTRONICS AND COMMUNICATIONS EQUIPMENT TECHNICIAN IV (GOV)",
  },
  { id: 755, name: "TELEPHONE TECHNICIAN" },
  { id: 756, name: "TELECOMMUNICATIONS TECHNICIAN" },
  { id: 757, name: "ELECTRONIC SYSTEMS TECHNICIAN" },
  { id: 758, name: "COMMUNICATION TECHNICIAN" },
  { id: 759, name: "ELECTRONIC PRODUCT TEST ENGINEER" },
  { id: 760, name: "AERONAUTICAL ENGINEERING TECHNICIAN" },
  { id: 761, name: "INDUSTRIAL MACHINERY AND TOOLS TECHNICIAN" },
  { id: 762, name: "MECHANICAL ENGINEERING TECHNICIAN (GENERAL)" },
  { id: 763, name: "MECHANICAL ENGINEERING TECHNICIAN (MOTORS AND ENGINES)" },
  { id: 764, name: "ELEVATOR TECHNICIAN" },
  { id: 765, name: "POWER PLANT TECHNICIAN" },
  { id: 766, name: "AUTO SERVICE TECHNICIAN" },
  { id: 767, name: "CHEMICAL ENGINEERING TECHNICIAN (GENERAL)" },
  { id: 768, name: "CHEMICAL PROCESS ENGINEERING TECHNICIAN" },
  { id: 769, name: "DRAFTSMAN (GENERAL)" },
  { id: 770, name: "ARCHITECTURAL DRAFTSMAN" },
  { id: 771, name: "CIVIL ENGINEERING DRAFTSMAN" },
  { id: 772, name: "ELECTRICAL DRAFTSMAN" },
  { id: 773, name: "MECHANICAL DRAFTSMAN" },
  { id: 774, name: "DRAFTSMAN (GOV)" },
  { id: 775, name: "ARTIST-ILLUSTRATOR" },
  { id: 776, name: "ARCHITECTURAL DESIGNER" },
  { id: 777, name: "SERVICEMAN" },
  { id: 778, name: "PRODUCTION TECHNICIAN" },
  { id: 779, name: "COMPUTER PROGRAMMING ASSISTANT" },
  { id: 780, name: "COMPUTER SYSTEMS ANALYST" },
  { id: 781, name: "COMPUTER EQUIPMENT OPERATOR" },
  { id: 782, name: "ELECTRONIC COMPUTER OPERATOR" },
  { id: 783, name: "COMPUTER OPERATOR (GOV)" },
  { id: 784, name: "COMPUTER OPERATOR I (GOV)" },
  { id: 785, name: "COMPUTER AIDED DESIGN (CAD) OPERATOR" },
  { id: 786, name: "COMPUTER OPERATOR" },
  { id: 787, name: "AUTOCAD OPERATOR" },
  { id: 788, name: "COMPUTER AIDED DRAFTING & DESIGN DRAFTSMAN" },
  { id: 789, name: "DESKTOP PUBLISHING OPERATOR" },
  { id: 790, name: "PRODUCTION CONTROLLER" },
  { id: 791, name: "PHOTOGRAPHER (GENERAL)" },
  { id: 792, name: "CAMERAMAN" },
  { id: 793, name: "CINEMA PROJECTIONIST" },
  { id: 794, name: "PUBLIC ADDRESS EQUIPMENT OPERATOR" },
  { id: 795, name: "BROADCAST OPERATOR (GOV)" },
  { id: 796, name: "NETWORK CONTROLLER I (GOV)" },
  { id: 797, name: "TV BROADCASTING EQUIPMENT OPERATOR" },
  { id: 798, name: "MEDICAL X-RAY TECHNICIAN" },
  { id: 799, name: "ULTRASOUND MACHINE TECHNICIAN" },
  { id: 800, name: "ACUPRESSURE TECHNICIAN" },
  { id: 801, name: "MEDICAL LABORATORY TECHNICIAN" },
  { id: 802, name: "MEDICAL EQUIPMENT TECHNICIAN" },
  { id: 803, name: "ELECTRONIC EQUIPMENT OPERATOR" },
  { id: 804, name: "PRINTING SCHEDULER (GOV)" },
  { id: 805, name: "FIBER OPTIC TECHNICIAN" },
  { id: 806, name: "OFFICER MARINE ENGINEER" },
  { id: 807, name: "DECK CADET" },
  { id: 808, name: "FLIGHT NAVIGATOR" },
  { id: 809, name: "PILOT (GOV)" },
  { id: 810, name: "QUALITY CONTROL/ASSURANCE INSPECTOR (PADC - GOV)" },
  {
    id: 811,
    name: "SENIOR QUALITY CONTROL/ASSURANCE INSPECTOR (NON-PADC) (GOV)",
  },
  { id: 812, name: "QUALITY CONTROL/ASSURANCE OFFICER" },
  { id: 813, name: "AIRCRAFT MAINTENANCE TECHNICIAN" },
  { id: 814, name: "AIRCRAFT MAINTENANCE ENGINEER" },
  { id: 815, name: "BUILDING INSPECTOR (GOV)" },
  { id: 816, name: "BUILDING COORDINATOR" },
  { id: 817, name: "QUALITY INSPECTOR" },
  { id: 818, name: "SAFETY INSPECTOR" },
  { id: 819, name: "SANITARY INSPECTOR" },
  { id: 820, name: "VEHICLES/POLLUTION INSPECTOR" },
  { id: 821, name: "QUALITY ANALYST" },
  { id: 822, name: "QUALITY ASSURANCE INSPECTOR" },
  { id: 823, name: "QUALITY CONTROL ASSISTANT" },
  { id: 824, name: "QUALITY ASSURANCE STAFF" },
  { id: 825, name: "COMMUNICATION CONTROL OPERATOR" },
  { id: 826, name: "SAFETY OFFICER" },
  { id: 827, name: "AUDIO-VISUAL AID TECHNICIAN (GOV)" },
  { id: 828, name: "AUDIO-VISUAL ASSISTANT (GOV)" },
  { id: 829, name: "AUDIO-VISUAL EQUIPMENT TECHNICIAN" },
  { id: 830, name: "RADIO/TV TECHNICIAN" },
  { id: 831, name: "SCIENCE RESEARCH ASSISTANT (GOV)" },
  { id: 832, name: "EXTENSION OFFICER" },
  { id: 833, name: "AGRONOMY TECHNICIAN" },
  { id: 834, name: "FARM TECHNICIAN" },
  { id: 835, name: "AGRICULTURAL PRODUCTS INSPECTOR (GOV)" },
  { id: 836, name: "AGRICULTURAL TECHNICIAN (GOV)" },
  { id: 837, name: "AGRICULTURAL TECHNICIAN" },
  { id: 838, name: "PEST CONTROL TECHNICIAN (GOV)" },
  { id: 839, name: "ANIMAL TECHNICIAN" },
  { id: 840, name: "MEDICAL ASSISTANT" },
  { id: 841, name: "MEDICAL TRANSCRIPTIONIST" },
  { id: 842, name: "DENTAL ASSISTANT" },
  { id: 843, name: "DENTAL AIDE" },
  { id: 844, name: "SCHOOL DENTAL ASSISTANT" },
  { id: 845, name: "VETERINARY ASSISTANT" },
  { id: 846, name: "EQUINE EVALUATOR (GOV)" },
  { id: 847, name: "PHARMACEUTICAL ASSISTANT" },
  { id: 848, name: "BARANGAY HEALTH AIDE (GOV)" },
  { id: 849, name: "LABORATORY TECHNICIAN" },
  { id: 850, name: "RADIOLOGY TECHNICIAN" },
  { id: 851, name: "BIOMEDICAL TECHNICIAN" },
  { id: 852, name: "PHYSICAL THERAPY TECHNICIAN" },
  { id: 853, name: "PROSTHETICS TECHNICIAN" },
  { id: 854, name: "OCCUPATIONAL THERAPY TECHNICIAN" },
  { id: 855, name: "AUXILLIARY NURSE" },
  { id: 856, name: "NURSING ASSOCIATE PROFESSIONAL" },
  { id: 857, name: "AUXILLIARY MIDWIFE" },
  { id: 858, name: "MIDWIFERY ASSOCIATE PROFESSIONAL" },
  { id: 859, name: "MIDWIFE I (GOV)" },
  { id: 860, name: "TRADITIONAL MEDICINE PRACTITIONER" },
  { id: 861, name: "TEACHER AIDE" },
  { id: 862, name: "TEACHER ASSISTANT" },
  { id: 863, name: "TEACHING ASSOCIATE PROFESSIONAL" },
  { id: 864, name: "TEACHING FELLOW" },
  { id: 865, name: "PRIVATE TUTOR" },
  { id: 866, name: "SECURITIES SALESMAN" },
  { id: 867, name: "LIAISON OFFICER" },
  { id: 868, name: "FIELD OPERATIONS ASSISTANT I (GOV)" },
  { id: 869, name: "FIELD OPERATIONS ASSISTANT II (GOV)" },
  { id: 870, name: "SENIOR GENERAL INSURANCE SPECIALIST (GOV)" },
  { id: 871, name: "COLLECTION ASSISTANT" },
  { id: 872, name: "SALES REPRESENTATIVE I (GOV)" },
  { id: 873, name: "SALES REPRESENTATIVE IV (GOV)" },
  { id: 874, name: "REAL ESTATE BROKER" },
  { id: 875, name: "TRAVEL COORDINATOR" },
  { id: 876, name: "RESERVATION OFFICER" },
  { id: 877, name: "TICKETING OFFICER" },
  { id: 878, name: "MANUFACTURER'S AGENT" },
  { id: 879, name: "MARKETING ASSISTANT" },
  { id: 880, name: "MEDICAL REPRESENTATIVE" },
  { id: 881, name: "TECHNICAL AND COMMERCIAL SALES REPRESENTATIVE" },
  { id: 882, name: "SALES ENGINEER" },
  { id: 883, name: "SERVICE ENGINEER" },
  { id: 884, name: "SALES ANALYST" },
  { id: 885, name: "SALES & MARKETING ASSISTANT" },
  { id: 886, name: "SALES INVENTORY" },
  { id: 887, name: "PRODUCT SUPPORT ENGINEER" },
  { id: 888, name: "DEALER" },
  { id: 889, name: "PURCHASING AGENT" },
  { id: 890, name: "BUYER" },
  { id: 891, name: "BUYER, MERCHANDISE, RETAILER" },
  { id: 892, name: "PURCHASER" },
  { id: 893, name: "APPRAISER" },
  { id: 894, name: "LIVELIHOOD ASSISTANT A (GOV)" },
  { id: 895, name: "LOANS ASSISTANT" },
  { id: 896, name: "AUDIT ASSISTANT" },
  { id: 897, name: "FINANCE ASSOCIATE PROFESSIONAL" },
  { id: 898, name: "SALES ASSOCIATE PROFESSIONAL" },
  { id: 899, name: "ASSISTANT NATIONAL CASHIER (GOV)" },
  { id: 900, name: "SALES COORDINATOR" },
  { id: 901, name: "RETAIL ASSOCIATE" },
  { id: 902, name: "PRODUCT SPECIALIST" },
  { id: 903, name: "WAREHOUSE SUPERVISOR" },
  { id: 904, name: "LOGISTICS & WAREHOUSE OFFICER" },
  { id: 905, name: "LABOR CONTRACTOR" },
  { id: 906, name: "JOB PLACEMENT OFFICER" },
  { id: 907, name: "RECRUITMENT OFFICER" },
  { id: 908, name: "SPORTS AGENT" },
  { id: 909, name: "ADVERTISING SALESMAN" },
  { id: 910, name: "BUSINESS SERVICES SALESMAN" },
  { id: 911, name: "INVESTMENT STAFF" },
  { id: 912, name: "ASSISTANT SECRETARY" },
  { id: 913, name: "ADMINISTRATIVE SECRETARY" },
  { id: 914, name: "TECHNICAL ASSISTANT" },
  { id: 915, name: "PLANNING ASSISTANT" },
  { id: 916, name: "PROCUREMENT ASSISTANT" },
  { id: 917, name: "PUBLIC SERVICES ASSISTANT (GOV)" },
  { id: 918, name: "INFORMATION ASSISTANT I (GOV)" },
  { id: 919, name: "LOCAL LEGISLATIVE STAFF ASSISTANT I (GOV)" },
  { id: 920, name: "LOCAL TREASURY OPERATIONS ASSISTANT (GOV)" },
  { id: 921, name: "PRIVATE SECRETARY" },
  { id: 922, name: "INSURANCE ASSISTANT" },
  { id: 923, name: "COURT CLERK" },
  { id: 924, name: "LAW CLERK" },
  { id: 925, name: "LEGAL CLERK" },
  { id: 926, name: "LEGAL AND RELATED BUSINESS ASSOCIATE PROFESSIONAL" },
  { id: 927, name: "INSURANCE SPECIALIST I (GOV)" },
  { id: 928, name: "LEGAL AIDE (GOV)" },
  { id: 929, name: "LEGAL ASSISTANT (GOV)" },
  { id: 930, name: "LEGAL ASSISTANT I (GOV)" },
  { id: 931, name: "LEGAL ASSISTANT II (GOV)" },
  { id: 932, name: "LEGAL ASSISTANT" },
  { id: 933, name: "LEGISLATIVE STAFF ASSISTANT" },
  { id: 934, name: "BOOKKEEPER" },
  { id: 935, name: "BOOKKEEPER (GOV)" },
  { id: 936, name: "SENIOR BOOKKEEPER" },
  { id: 937, name: "ACCOUNTING ASSISTANT" },
  { id: 938, name: "MATHEMATICAL ASSISTANT" },
  { id: 939, name: "ENUMERATOR" },
  { id: 940, name: "CONSULAR OFFICIAL" },
  { id: 941, name: "SHOP SERVICE ADVISOR" },
  { id: 942, name: "PROJECT ASSISTANT" },
  { id: 943, name: "PROPERTY CUSTODIAN" },
  { id: 944, name: "MATERIALS ENGINEER" },
  { id: 945, name: "CUSTOMS REPRESENTATIVE" },
  { id: 946, name: "TAX OFFICER" },
  { id: 947, name: "PRICE INSPECTOR" },
  { id: 948, name: "OVERSEAS WORKER WELFARE ASSISTANT (GOV)" },
  { id: 949, name: "AGENT" },
  { id: 950, name: "DETECTIVE" },
  { id: 951, name: "POLICE DETECTIVE" },
  { id: 952, name: "POLICE INSPECTOR" },
  { id: 953, name: "POLICE INSPECTOR I (GOV)" },
  { id: 954, name: "FINGERPRINT TECHNICIAN" },
  { id: 955, name: "INSPECTOR (PNP) (GOV)" },
  { id: 956, name: "INTELLIGENCE AGENT I (GOV)" },
  { id: 957, name: "JAIL OFFICER I (GOV)" },
  { id: 958, name: "PSYCHIATRIC SOCIAL WORKER ASSISTANT" },
  { id: 959, name: "SOCIAL WORKER ASSISTANT" },
  { id: 960, name: "SOCIAL WORK ASSOCIATE PROFESSIONAL" },
  { id: 961, name: "HUMAN RESOURCE MANAGEMENT AIDE (GOV)" },
  { id: 962, name: "HUMAN RESOURCE MANAGEMENT ASSISTANT (GOV)" },
  { id: 963, name: "HUMAN RESOURCE MANAGEMENT ASSISTANT" },
  { id: 964, name: "HUMAN RESOURCE DEVELOPMENT ASSISTANT" },
  { id: 965, name: "DISPLAY ARTIST" },
  { id: 966, name: "INTERIOR DECORATOR" },
  { id: 967, name: "COMMERCIAL DECORATOR AND DESIGNER" },
  { id: 968, name: "FASHION DESIGNER" },
  { id: 969, name: "INDUSTRIAL AND COMMERCIAL PRODUCTS DESIGNER" },
  { id: 970, name: "INTERIOR DESIGNER" },
  { id: 971, name: "TATOOIST" },
  { id: 972, name: "FASHION CONSULTANT" },
  { id: 973, name: "RADIO ANNOUNCER" },
  { id: 974, name: "TELEVISION ANNOUNCER" },
  { id: 975, name: "COMPERE (EMCEE/SHOW HOST)" },
  { id: 976, name: "FILM PREVIEW ASSISTANT" },
  { id: 977, name: "PUBLIC RELATIONS ASSISTANT (GOV)" },
  { id: 978, name: "NEWS REPORTER (GOV)" },
  { id: 979, name: "NEWS REPORTER" },
  { id: 980, name: "DISC JOCKEY" },
  { id: 981, name: "MEDIA PRODUCTION STAFF" },
  { id: 982, name: "ATHLETE" },
  { id: 983, name: "SPORTS COACH" },
  { id: 984, name: "AEROBIC INSTRUCTOR" },
  { id: 985, name: "PHYSICAL TRAINER" },
  { id: 986, name: "FITNESS INSTRUCTOR" },
  { id: 987, name: "DANCE INSTRUCTOR" },
  { id: 988, name: "STENOGRAPHER CLERK" },
  { id: 989, name: "TYPIST CLERK" },
  { id: 990, name: "WORD PROCESSING CLERK" },
  { id: 991, name: "DATA ENTRY CLERK (COMPUTER)" },
  { id: 992, name: "DATA ENTRY CLERK (CONVERTER - CARD TO TAPE)" },
  { id: 993, name: "DATA ENTRY CLERK (ELECTRONIC MAIL)" },
  { id: 994, name: "DATA ENTRY CLERK (PUNCHING MACHINE - CARD TO TAPE)" },
  { id: 995, name: "DATA ENCODER" },
  { id: 996, name: "DATA ENTRY OPERATOR" },
  { id: 997, name: "CLERK-PROCESSOR" },
  { id: 998, name: "DATA ENCODER (GOV)" },
  { id: 999, name: "DATA ENCODER III (GOV)" },
  { id: 1000, name: "DATA ENCODER IV (GOV)" },
  { id: 1001, name: "DATA ENCODER-CONTROLLER (GOV)" },
  { id: 1002, name: "COMPUTER OPERATOR (SYSTEMS)" },
  { id: 1003, name: "DESKTOP PUBLISHING ENCODER" },
  { id: 1004, name: "MUSICAL ENCODER" },
  { id: 1005, name: "ACCOUNTING MACHINE OPERATOR I" },
  { id: 1006, name: "SECRETARY" },
  { id: 1007, name: "LEGAL SECRETARY" },
  { id: 1008, name: "MEDICAL SECRETARY" },
  { id: 1009, name: "OFFICE SECRETARY" },
  { id: 1010, name: "TYPING SECRETARY" },
  { id: 1011, name: "CORPORATE SECRETARY" },
  { id: 1012, name: "EXECUTIVE SECRETARY" },
  { id: 1013, name: "ACCOUNTING CLERK" },
  { id: 1014, name: "BOOKKEEPING CLERK" },
  { id: 1015, name: "PAYROLL CLERK" },
  { id: 1016, name: "PERSONNEL CLERK" },
  { id: 1017, name: "ASSESSMENT CLERK II (GOV)" },
  { id: 1018, name: "ASSESSMENT CLERK" },
  { id: 1019, name: "ASSISTANT CLAIMS PROCESSOR I (GOV)" },
  { id: 1020, name: "LEASING CLERK" },
  { id: 1021, name: "MANPOWER DEVELOPMENT ASSISTANT (GOV)" },
  { id: 1022, name: "TEST TECHNICIAN (GOV)" },
  { id: 1023, name: "TEST TECHNICIAN" },
  { id: 1024, name: "AUDITING CLERK" },
  { id: 1025, name: "ACCOUNTING STAFF" },
  { id: 1026, name: "ACCOUNTING OFFICER" },
  { id: 1027, name: "HUMAN RESOURCE DEVELOPMENT CLERK" },
  { id: 1028, name: "HUMAN RESOURCE MANAGEMENT CLERK" },
  { id: 1029, name: "FINANCE CLERK" },
  { id: 1030, name: "INSURANCE CLERK" },
  { id: 1031, name: "MORTGAGE CLERK" },
  { id: 1032, name: "STATISTICAL CLERK" },
  { id: 1033, name: "FINANCIAL PLANNING ASSISTANT A (GOV)" },
  { id: 1034, name: "TARIFF/TAXATION ASSISTANT (GOV)" },
  { id: 1035, name: "BANK CLERK" },
  { id: 1036, name: "MONEY SORTER" },
  { id: 1037, name: "RESEARCH ANALYST" },
  { id: 1038, name: "SETTLEMENT STAFF" },
  { id: 1039, name: "INVENTORY CLERK" },
  { id: 1040, name: "STOCK CLERK" },
  { id: 1041, name: "STOCK CONTROL CLERK" },
  { id: 1042, name: "STOREROOM CLERK" },
  { id: 1043, name: "WAREHOUSE CLERK" },
  { id: 1044, name: "STOREKEEPER" },
  { id: 1045, name: "EDUCATION RESEARCH ASSISTANT I (GOV)" },
  { id: 1046, name: "WAREHOUSE/SHIPPING ASSISTANT A (GOV)" },
  { id: 1047, name: "WAREHOUSEMAN" },
  { id: 1048, name: "RECEIVING CLERK" },
  { id: 1049, name: "LOGISTICS COORDINATOR" },
  { id: 1050, name: "STOCK CONTROLLER" },
  { id: 1051, name: "PLANNING/MATERIALS CLERK" },
  { id: 1052, name: "PRODUCTION/PLANNING CLERK" },
  { id: 1053, name: "TIMEKEEPER" },
  { id: 1054, name: "JEWELRY APPRAISER" },
  { id: 1055, name: "PRODUCTION PLANNING AND CONTROL ASSISTANT (GOV)" },
  { id: 1056, name: "PRODUCTION ASSISTANT" },
  { id: 1057, name: "TRANSPORT CLERK" },
  { id: 1058, name: "ROAD TRANSPORT DISPATCHER" },
  { id: 1059, name: "SHIPPING CLERK" },
  { id: 1060, name: "DRIVING SKILL RATER (GOV)" },
  { id: 1061, name: "MOTORPOOL MAINTENANCE CLERK" },
  { id: 1062, name: "SUPPLY AND EQUIPMENT CLERK" },
  { id: 1063, name: "LIBRARY ASSISTANT" },
  { id: 1064, name: "LIBRARY CLERK" },
  { id: 1065, name: "MAIL SORTING CLERK" },
  { id: 1066, name: "MAIL DISPATCHING CLERK" },
  { id: 1067, name: "MAIL CARRIER" },
  { id: 1068, name: "POSTMAN" },
  { id: 1069, name: "MAIL SORTER" },
  { id: 1070, name: "CODING CLERK" },
  { id: 1071, name: "DOCUMENTATION CLERK" },
  { id: 1072, name: "ADMINISTRATIVE CLERK" },
  { id: 1073, name: "RECORDS/PERSONNEL CLERK" },
  { id: 1074, name: "ADMINISTRATION SERVICES ASSISTANT A (GOV)" },
  { id: 1075, name: "ADMINISTRATIVE ASSISTANT" },
  { id: 1076, name: "ADMINISTRATIVE ASSISTANT (GOV)" },
  { id: 1077, name: "CLERK I (GOV)" },
  { id: 1078, name: "CLERK II (GOV)" },
  { id: 1079, name: "CLERK III (GOV)" },
  { id: 1080, name: "CLERK IV (GOV)" },
  { id: 1081, name: "MEMBERS SERVICES ASSISTANT I (GOV)" },
  { id: 1082, name: "TRAINING ASSISTANT" },
  { id: 1083, name: "PURCHASING CLERK" },
  { id: 1084, name: "MEDICAL CLERK" },
  { id: 1085, name: "RECORDS CLERK" },
  { id: 1086, name: "EXPORT/IMPORT CLERK" },
  { id: 1087, name: "LIST/ADDRESSES CLERK" },
  { id: 1088, name: "RECORDS ASSISTANT (GOV)" },
  { id: 1089, name: "RESEARCH CLERK (GOV)" },
  { id: 1090, name: "RESEARCH CLERK" },
  { id: 1091, name: "DOCUMENTATION STAFF" },
  { id: 1092, name: "OFFICE CLERK" },
  { id: 1093, name: "TECHNICAL SUPPORT STAFF" },
  { id: 1094, name: "MONITORING CLERK" },
  { id: 1095, name: "MANAGEMENT INFORMATION SYSTEM STAFF" },
  { id: 1096, name: "GUIDANCE SERVICES STAFF" },
  { id: 1097, name: "CASHIER" },
  { id: 1098, name: "CASHIER AIDE" },
  { id: 1099, name: "BANK CASHIER" },
  { id: 1100, name: "CASH DESK CASHIER" },
  { id: 1101, name: "OFFICE CASHIER" },
  { id: 1102, name: "DISBURSING CLERK" },
  { id: 1103, name: "TICKET CLERK" },
  { id: 1104, name: "CASHIER A (GOV)" },
  { id: 1105, name: "CASHIER B (GOV)" },
  { id: 1106, name: "CASHIERING ASSISTANT (GOV)" },
  { id: 1107, name: "SENIOR CASHIER" },
  { id: 1108, name: "INVOICING CLERK" },
  { id: 1109, name: "COUNTER CLERK" },
  { id: 1110, name: "POST OFFICE COUNTER CLERK" },
  { id: 1111, name: "MONEY CHANGER" },
  { id: 1112, name: "TELLER" },
  { id: 1113, name: "BANK TELLER" },
  { id: 1114, name: "BANK TELLER I (GOV)" },
  { id: 1115, name: "CROUPIER" },
  { id: 1116, name: "PAWNBROKER" },
  { id: 1117, name: "BILLING CLERK" },
  { id: 1118, name: "BILL COLLECTOR" },
  { id: 1119, name: "CASH COLLECTOR" },
  { id: 1120, name: "DEBT COLLECTOR" },
  { id: 1121, name: "COLLECTOR, MONEY, VENDING MACHINE" },
  { id: 1122, name: "BILLING/CABLE ASSISTANT (GOV)" },
  { id: 1123, name: "CREDIT AND COLLECTION CLERK" },
  { id: 1124, name: "TICKET ISSUING CLERK" },
  { id: 1125, name: "TRAVEL AGENCY CLERK" },
  { id: 1126, name: "TRAVEL CLERK (AIRLINES)" },
  { id: 1127, name: "INFORMATION CLERK" },
  { id: 1128, name: "ADMISSION CLERK" },
  { id: 1129, name: "APPOINTMENTS CLERK" },
  { id: 1130, name: "INQUIRIES CLERK" },
  { id: 1131, name: "DOCTOR'S RECEPTIONIST" },
  { id: 1132, name: "DENTAL RECEPTIONIST" },
  { id: 1133, name: "RECEPTIONIST (GENERAL)" },
  { id: 1134, name: "HOTEL RECEPTIONIST" },
  { id: 1135, name: "MEDICAL RECEPTIONIST" },
  { id: 1136, name: "ASSISTANT INFORMATION OFFICER (GOV)" },
  { id: 1137, name: "COMMUNITY RELATIONS ASSISTANT A (GOV)" },
  { id: 1138, name: "TOURISM OPERATIONS ASSISTANT (GOV)" },
  { id: 1139, name: "TOURIST RECEPTIONIST I (GOV)" },
  { id: 1140, name: "TOURIST RECEPTIONIST II (GOV)" },
  { id: 1141, name: "TOURIST RECEPTIONIST III (GOV)" },
  { id: 1142, name: "CUSTOMER SERVICE ASSISTANT" },
  { id: 1143, name: "FRONT DESK CLERK" },
  { id: 1144, name: "FRONT DESK OFFICER" },
  { id: 1145, name: "RESERVATION CLERK" },
  { id: 1146, name: "CALL CENTER AGENT" },
  { id: 1147, name: "TELEPHONE OPERATOR" },
  { id: 1148, name: "CABIN ATTENDANT (AIRCRAFT)" },
  { id: 1149, name: "TRAVEL ATTENDANT" },
  { id: 1150, name: "AIRLINE STEWARD" },
  { id: 1151, name: "FLIGHT STEWARD" },
  { id: 1152, name: "SHIP STEWARD" },
  { id: 1153, name: "BUS CONDUCTOR" },
  { id: 1154, name: "PASSENGER CAR CONDUCTOR" },
  { id: 1155, name: "TRAVEL GUIDE" },
  { id: 1156, name: "MUSEUM GUIDE" },
  { id: 1157, name: "HOUSEKEEPER (PRIVATE)" },
  { id: 1158, name: "HOUSEKEEPER (HOTEL AND RESORTS)" },
  { id: 1159, name: "HOTEL HOUSEKEEPING ATTENDANT" },
  { id: 1160, name: "BABY SITTER" },
  { id: 1161, name: "CHILD-CARE WORKER" },
  { id: 1162, name: "NURSEMAID" },
  { id: 1163, name: "DAY CARE WORKER" },
  { id: 1164, name: "NURSING ATTENDANT I (GOV)" },
  { id: 1165, name: "NURSING CLINIC AIDE" },
  { id: 1166, name: "CAREGIVER (INSTITUTION-BASED)" },
  { id: 1167, name: "HOTEL CONCIERGE" },
  { id: 1168, name: "ASTROLOGER" },
  { id: 1169, name: "SAUNA BATH ATTENDANT" },
  { id: 1170, name: "BARBER" },
  { id: 1171, name: "BARBER-HAIRDRESSER" },
  { id: 1172, name: "BEAUTICIAN" },
  { id: 1173, name: "BEAUTY CARE EQUIPMENT OPERATOR" },
  { id: 1174, name: "COSMETOLOGIST" },
  { id: 1175, name: "HAIRDRESSER" },
  { id: 1176, name: "MANICURIST/PEDICURIST" },
  { id: 1177, name: "MORTUARY BEAUTICIAN" },
  { id: 1178, name: "MAKE-UP ARTIST (GOV)" },
  { id: 1179, name: "BEAUTY CONSULTANT" },
  { id: 1180, name: "FACIAL/SKIN TREATMENT CONSULTANT" },
  { id: 1181, name: "HAIR STYLIST" },
  { id: 1182, name: "CHAPERON" },
  { id: 1183, name: "VALET" },
  { id: 1184, name: "CREMATOR" },
  { id: 1185, name: "EMBALMER" },
  { id: 1186, name: "CASINO DEALER" },
  { id: 1187, name: "FIREMAN" },
  { id: 1188, name: "ASSISTANT FIRE MARSHALL (GOV)" },
  { id: 1189, name: "FIRE OFFICER (GOV)" },
  { id: 1190, name: "POLICE OFFICER" },
  { id: 1191, name: "POLICE PATROLMAN" },
  { id: 1192, name: "POLICE PATROLWOMAN" },
  { id: 1193, name: "POLICEMAN" },
  { id: 1194, name: "POLICEWOMAN" },
  { id: 1195, name: "PRIVATE POLICE GUARD" },
  { id: 1196, name: "POLICE OFFICER (PNP)" },
  { id: 1197, name: "SPECIAL POLICE CORPORAL (GOV)" },
  { id: 1198, name: "TOUR MARSHALL" },
  { id: 1199, name: "BODYGUARD" },
  { id: 1200, name: "GAME WARDEN" },
  { id: 1200, name: "GAME WARDEN" },
  { id: 1201, name: "LIFEGUARD" },
  { id: 1202, name: "SECURITY GUARD" },
  { id: 1203, name: "PRIVATE INVESTIGATOR/CRIMINOLOGY" },
  { id: 1204, name: "WATCHMAN" },
  { id: 1205, name: "CIVIL SECURITY ASSISTANT (GOV)" },
  { id: 1206, name: "CUSTOMS GATEKEEPER" },
  { id: 1207, name: "WATCHMAN (GOV)" },
  { id: 1208, name: "CIVILIAN GUARD" },
  { id: 1209, name: "LADY GUARD" },
  { id: 1210, name: "SECURITY ASSISTANT" },
  { id: 1211, name: "AVIATION SECURITY GUARD" },
  { id: 1212, name: "MODEL ADVERTISING" },
  { id: 1213, name: "ARTIST MODEL" },
  { id: 1214, name: "FASHION MODEL" },
  { id: 1215, name: "SHOP ASSISTANT" },
  { id: 1216, name: "GASOLINE ASSISTANT" },
  { id: 1217, name: "DEMONSTRATOR" },
  { id: 1218, name: "PRODUCT DEMONSTRATOR" },
  { id: 1219, name: "RETAIL TRADE SALESMAN" },
  { id: 1220, name: "WHOLESALE TRADE SALESMAN" },
  { id: 1221, name: "SALESMAN" },
  { id: 1222, name: "DEPARTMENT STORE SALESPERSON" },
  { id: 1223, name: "HOTEL AND RESTAURANT SALESPERSON" },
  { id: 1224, name: "PROMO GIRL" },
  { id: 1225, name: "FIELD INTERVIEWER" },
  { id: 1226, name: "SALES AND BANQUET EXECUTIVES" },
  { id: 1227, name: "ANIMAL KEEPER (GOV)" },
  { id: 1228, name: "ANIMAL RAISER" },
  { id: 1229, name: "CONCESSIONAIRE" },
  { id: 1230, name: "BEEWAX GATHERER" },
  { id: 1231, name: "DEEP-SEA FISHERMAN" },
  { id: 1232, name: "MINER (GENERAL)" },
  { id: 1233, name: "MINE SAMPLER" },
  { id: 1234, name: "STONEWORK LAYOUT MAN" },
  { id: 1235, name: "MASON (GENERAL)" },
  { id: 1236, name: "PLASTERER (GENERAL)" },
  { id: 1237, name: "CONSTRUCTION STONEMASON" },
  { id: 1238, name: "MASON (GOV)" },
  { id: 1239, name: "MASON LEADMAN" },
  { id: 1240, name: "CARPENTER (GENERAL)" },
  { id: 1241, name: "CONSTRUCTION CARPENTER" },
  { id: 1242, name: "CARPENTER (GOV)" },
  { id: 1243, name: "BUILDING MAINTENANCE MAN" },
  { id: 1244, name: "SCAFFOLDER" },
  { id: 1245, name: "FLOOR LAYER" },
  { id: 1246, name: "TILE SETTER" },
  { id: 1247, name: "BUILDING EXTERIOR CLEANER" },
  { id: 1248, name: "ROOFING GLAZIER" },
  { id: 1249, name: "PLUMBER (GOV)" },
  { id: 1250, name: "PLUMBING AND TINNING INSPECTOR (GOV)" },
  { id: 1251, name: "MASTER PLUMBER (GOV)" },
  { id: 1252, name: "MASTER PLUMBER" },
  { id: 1253, name: "PAINTER" },
  { id: 1254, name: "BUILDING PAINTER" },
  { id: 1255, name: "CONSTRUCTION PAINTER" },
  { id: 1256, name: "PAINTER (GOV)" },
  { id: 1257, name: "AUTOMOTIVE PAINTER" },
  { id: 1258, name: "WELDER" },
  { id: 1259, name: "ELECTRIC WELDER" },
  { id: 1260, name: "ELECTRIC ARC WELDER (GENERAL)" },
  { id: 1261, name: "GAS WELDER" },
  { id: 1262, name: "METAL ARC WELDER" },
  { id: 1263, name: "SHIELDED METAL ARC WELDER" },
  { id: 1264, name: "WELDER (GOV)" },
  { id: 1265, name: "PIPE WELDER" },
  { id: 1266, name: "STRUCTURAL WELDER" },
  { id: 1267, name: "TIG WELDER" },
  { id: 1268, name: "AUTOBODY REPAIRMAN" },
  { id: 1269, name: "IRON WORKS FABRICATOR" },
  { id: 1270, name: "STEELMAN" },
  { id: 1271, name: "METAL FABRICATOR" },
  { id: 1272, name: "ALUMINUM INSTALLER" },
  { id: 1273, name: "RIGGER" },
  { id: 1274, name: "CRAFTS AND TRADE HELPER" },
  { id: 1276, name: "BORING-MACHINE SETTER-OPERATOR" },
  { id: 1277, name: "MACHINE-TOOL SETTER-OPERATOR" },
  { id: 1278, name: "BUFFING MACHINE OPERATOR" },
  { id: 1279, name: "METAL FINISHER" },
  { id: 1280, name: "AUTOMOBILE MECHANIC" },
  { id: 1281, name: "AUTOMOTIVE MECHANIC (LIGHT DUTY)" },
  { id: 1282, name: "MOTOR TRUCK MECHANIC" },
  { id: 1283, name: "SMALL ENGINE MECHANIC" },
  { id: 1284, name: "AUTOMOTIVE MECHANIC (GOV)" },
  { id: 1285, name: "MECHANIC" },
  { id: 1286, name: "MECHANICAL PLANT OPERATOR (GOV)" },
  { id: 1287, name: "SUPERVISING AUTOMOTIVE SHOP MECHANIC (GOV)" },
  { id: 1288, name: "AUTOMOTIVE MECHANIC" },
  { id: 1289, name: "DRIVER/MECHANIC" },
  { id: 1290, name: "CHIEF MECHANIC/TECHNICIAN" },
  { id: 1292, name: "AIRCRAFT ENGINE MECHANIC" },
  { id: 1293, name: "AIRCRAFT ENGINE SERVICE MECHANIC" },
  { id: 1294, name: "AIRCRAFT PRODUCTION/MAINTENANCE ASSISTANT A (GOV-IUG)" },
  { id: 1295, name: "AIRCRAFT MECHANIC" },
  { id: 1296, name: "MACHINERY ERECTOR AND INSTALLER" },
  { id: 1297, name: "MACHINERY MECHANIC (GENERAL)" },
  { id: 1298, name: "METALWORKING MACHINE-TOOL MECHANIC" },
  { id: 1299, name: "OILER" },
  { id: 1300, name: "INDUSTRIAL EQUIPMENT FITTER" },
  { id: 1301, name: "HEAVY EQUIPMENT MECHANIC" },
  { id: 1302, name: "PRINTING TECHNICIAN (OFFSET)" },
  { id: 1303, name: "ADDING MACHINE TECHNICIAN" },
  { id: 1304, name: "MAINTENANCE TECHNICIAN (ELECTRICAL)" },
  { id: 1305, name: "MAINTENANCE TECHNICIAN (ELECTRONICS)" },
  { id: 1306, name: "ELECTRICAL GENERATOR FITTER" },
  { id: 1307, name: "ELECTRICAL MECHANIC" },
  { id: 1308, name: "ELECTRICAL TECHNICIAN" },
  { id: 1309, name: "BUILDING ELECTRICIAN" },
  { id: 1310, name: "ELECTRICIAN (GENERAL)" },
  { id: 1311, name: "INDUSTRIAL ELECTRICIAN" },
  { id: 1312, name: "MAINTENANCE ELECTRICIAN" },
  { id: 1313, name: "AUTO ELECTRICAL FOREMAN (GOV)" },
  { id: 1314, name: "AUTOMOTIVE ELECTRICIAN (GOV)" },
  { id: 1315, name: "AUTOMOTIVE EQUIPMENT INSPECTOR (GOV)" },
  { id: 1316, name: "AUTOMOTIVE EQUIPMENT INSPECTOR" },
  { id: 1317, name: "ELECTRICAL INSPECTOR (GOV)" },
  { id: 1318, name: "ELECTRICIAN (GOV)" },
  { id: 1319, name: "AUTOMOTIVE ELECTRICIAN" },
  { id: 1320, name: "ELECTRICAL HELPER" },
  { id: 1321, name: "ELECTRONIC PRODUCTS INSPECTOR" },
  { id: 1322, name: "ELECTRONIC PRODUCTS TESTER" },
  { id: 1323, name: "AUDIO ELECTRONICS SERVICER" },
  { id: 1324, name: "ELECTRONICS BUSINESS MACHINES TECHNICIAN" },
  { id: 1325, name: "ELECTRONICS TECHNICIAN" },
  { id: 1326, name: "COMPUTER TECHNICIAN" },
  { id: 1327, name: "COMPUTER NETWORK TECHNICIAN" },
  { id: 1328, name: "COMPUTER MAINTENANCE TECHNICIAN" },
  { id: 1329, name: "VIDEO TECHNICIAN" },
  { id: 1330, name: "CENTRAL OFFICE EQUIPMENT INSTALLER" },
  { id: 1331, name: "TELECOMMUNICATION EQUIPMENT INSTALLER" },
  { id: 1332, name: "LINE INSTALLER" },
  { id: 1333, name: "LINEMAN" },
  { id: 1334, name: "RIDE MAINTENANCE MECHANIC" },
  { id: 1335, name: "DENTAL TECHNICIAN" },
  { id: 1336, name: "JEWELLER (GENERAL)" },
  { id: 1337, name: "GLASS CUTTER" },
  { id: 1338, name: "SIGN MAKER" },
  { id: 1339, name: "WEED WEAVING HANDICRAFT WORKER" },
  { id: 1340, name: "WOODEN ARTICLES HANDICRAFT WORKER" },
  { id: 1341, name: "CARPET HANDICRAFT WORKER" },
  { id: 1342, name: "TEXTILE HANDICRAFT WORKER" },
  { id: 1343, name: "REPRODUCTION MACHINE OPERATOR" },
  { id: 1344, name: "PRINTER OPERATOR" },
  { id: 1345, name: "BLACK AND WHITE DEVELOPER" },
  { id: 1346, name: "PHOTOGRAPHIC FILM MAKER" },
  { id: 1347, name: "PHOTOGRAPH PRINTER" },
  { id: 1348, name: "PHOTO EDITOR (GOV)" },
  { id: 1349, name: "PHOTOGRAPHER (GOV)" },
  { id: 1350, name: "PHOTO EDITOR" },
  { id: 1351, name: "BOOKBINDER" },
  { id: 1352, name: "HAND AND MACHINE BOOKBINDER" },
  { id: 1353, name: "BOOK EMBOSSER" },
  { id: 1354, name: "HAND BOOK EMBOSSER" },
  { id: 1355, name: "MACHINE BOOK EMBOSSER" },
  { id: 1356, name: "HAND BOOKBINDER" },
  { id: 1357, name: "MACHINE BOOKBINDER" },
  { id: 1358, name: "BOOKBINDER (GOV)" },
  { id: 1359, name: "GARMENT PRINTER" },
  { id: 1360, name: "OFFICE MACHINE (REPRODUCTION PROCESSES) OPERATOR" },
  { id: 1361, name: "PHOTOCOPYING MACHINE OPERATOR" },
  { id: 1362, name: "PRINTING MACHINE OPERATOR" },
  { id: 1363, name: "COACH BODY BUILDER" },
  { id: 1364, name: "FURNITURE MAKER" },
  { id: 1365, name: "FIBER PICKER" },
  { id: 1366, name: "FABRIC REPAIRER" },
  { id: 1367, name: "WEAVER" },
  { id: 1368, name: "DRESSMAKER" },
  { id: 1369, name: "TAILOR" },
  { id: 1370, name: "EMBROIDERER" },
  { id: 1371, name: "HAND EMBROIDERER" },
  { id: 1372, name: "HAND SEWER" },
  { id: 1373, name: "SEWER" },
  { id: 1374, name: "GARMENT SEWER" },
  { id: 1375, name: "CLICKER CUTTER (MACHINE)" },
  { id: 1376, name: "SHOEMAKER" },
  { id: 1377, name: "ALUMINUM CUTTING MACHINE OPERATOR" },
  { id: 1378, name: "DIE-CUT OPERATOR" },
  { id: 1379, name: "GLASS TEMPERER" },
  { id: 1380, name: "MIXING MACHINE OPERATOR (GLASS)" },
  { id: 1381, name: "PAPER BAG AND ENVELOPE MAKER (MACHINE)" },
  { id: 1382, name: "PAPER BOX MAKER (MACHINE)" },
  { id: 1383, name: "PAPER CUTTING MACHINE OPERATOR (GOV)" },
  { id: 1384, name: "CRUSHER OPERATOR" },
  { id: 1385, name: "MILL OPERATOR (CHEMICAL AND RELATED PROCESSES)" },
  { id: 1386, name: "PETROLEUM REFINING PUMPMAN" },
  { id: 1387, name: "OIL TANKER PUMPMAN" },
  { id: 1388, name: "CHEMICAL PROCESSING PLANT OPERATOR (N.E.C.)" },
  { id: 1389, name: "FERTILIZER PLANT OPERATOR" },
  { id: 1390, name: "SOLAR POWER PLANT OPERATOR" },
  { id: 1391, name: "ELECTRICAL CONTROL OPERATOR (GOV)" },
  { id: 1392, name: "ASSEMBLY LINE OPERATOR (AUTOMATED)" },
  { id: 1393, name: "ROBOTICS ENGINEER" },
  { id: 1394, name: "BORING MACHINE OPERATOR (METAL)" },
  { id: 1395, name: "CONE-MAKING MACHINE OPERATOR (METAL)" },
  { id: 1396, name: "MACHINE TOOL MACHINE OPERATOR" },
  { id: 1397, name: "MILLING MACHINE OPERATOR" },
  { id: 1398, name: "TOOL MACHINE OPERATOR" },
  { id: 1399, name: "PRODUCTION MACHINE OPERATOR" },
  { id: 1400, name: "MACHINIST" },
  { id: 1400, name: "MACHINIST" },
  { id: 1401, name: "CAST CONCRETE PRODUCT MAKER" },
  { id: 1402, name: "FINISHING CONCRETE MACHINE OPERATOR" },
  { id: 1403, name: "PHARMACEUTICAL PRODUCTS MACHINE OPERATOR" },
  { id: 1404, name: "MATCH PRODUCTION MACHINE OPERATOR" },
  { id: 1405, name: "TIRE MOLDER" },
  { id: 1406, name: "TIRE BUILDER" },
  { id: 1407, name: "TIRE REBUILDER" },
  { id: 1408, name: "MOLDING MACHINE OPERATOR (PLASTICS)" },
  { id: 1409, name: "PLASTIC INJECTION MOLDING MACHINE OPERATOR" },
  { id: 1410, name: "PAINTING MACHINE OPERATOR (WOOD)" },
  { id: 1411, name: "FIBER-PREPARING MACHINE OPERATOR" },
  { id: 1412, name: "LACE WEAVER (MACHINE)" },
  { id: 1413, name: "NET PRODUCTION MACHINE OPERATOR" },
  { id: 1414, name: "SEWING MACHINE OPERATOR" },
  { id: 1415, name: "LAUNDERER (GENERAL)" },
  { id: 1416, name: "FINISHING MACHINE OPERATOR" },
  { id: 1417, name: "LAUNDERING MACHINE OPERATOR" },
  { id: 1418, name: "LAUNDRY PRESSING MACHINE OPERATOR" },
  { id: 1419, name: "WASHING/LAUNDRY MACHINE OPERATOR" },
  { id: 1420, name: "CLEANING MACHINE OPERATOR" },
  { id: 1421, name: "LAUNDRY WORKER" },
  { id: 1422, name: "LEATHER PREPARING MACHINE OPERATOR" },
  { id: 1423, name: "FOOTWEAR PRODUCTION MACHINE OPERATOR" },
  { id: 1424, name: "SHOE PRODUCTION MACHINE OPERATOR" },
  { id: 1425, name: "FABRIC WORKER I (GOV)" },
  { id: 1426, name: "CIGAR AND CIGARETTES PRODUCTION MACHINE OPERATOR" },
  { id: 1427, name: "MECHANICAL MACHINERY ASSEMBLER" },
  { id: 1428, name: "VEHICLE ASSEMBLER" },
  { id: 1429, name: "ASSEMBLY-LINE WORKER (AGRICULTURAL MACHINERY)" },
  { id: 1430, name: "ASSEMBLY-LINE WORKER (HEAVY MACHINERY)" },
  { id: 1431, name: "ELECTRICAL EQUIPMENT ASSEMBLER" },
  { id: 1432, name: "ELECTRONIC EQUIPMENT ASSEMBLER" },
  { id: 1433, name: "WATCH ASSEMBLER" },
  { id: 1434, name: "COMPUTER ASSEMBLER" },
  { id: 1435, name: "ASSEMBLY-LINE WORKER (DOLL AND STUFFED TOY)" },
  { id: 1436, name: "PACKING MACHINE OPERATOR" },
  { id: 1437, name: "MECHANICAL/ELECTRICAL EQUIPMENT OPERATOR I (GOV)" },
  { id: 1438, name: "DRIVER (GOV)" },
  { id: 1439, name: "DRIVER COURIER III (GOV)" },
  { id: 1440, name: "DRIVER-MECHANIC B (GOV)" },
  { id: 1441, name: "DRIVER COURIER" },
  { id: 1442, name: "DISPATCH RIDER" },
  { id: 1443, name: "MOTORCYCLE DRIVER/RIDER" },
  { id: 1444, name: "CAR DRIVER" },
  { id: 1445, name: "TAXI DRIVER" },
  { id: 1446, name: "VAN DRIVER" },
  { id: 1447, name: "PUBLIC UTILITY VEHICLE DRIVER (GOV)" },
  { id: 1448, name: "JEEPNEY DRIVER" },
  { id: 1449, name: "COMPANY DRIVER" },
  { id: 1450, name: "DELIVERY DRIVER" },
  { id: 1451, name: "BUS DRIVER" },
  { id: 1452, name: "TRUCK DRIVER" },
  { id: 1453, name: "HEAVY TRUCK DRIVER" },
  { id: 1454, name: "DUMP TRUCK DRIVER" },
  { id: 1455, name: "CHAUFFEUR/FAMILY DRIVER" },
  { id: 1456, name: "HARVESTER OPERATOR" },
  { id: 1457, name: "HEAVY EQUIPMENT OPERATOR" },
  { id: 1458, name: "HYDRAULIC BACKHOE EXCAVATOR OPERATOR" },
  { id: 1459, name: "MOBILE CRANE OPERATOR" },
  { id: 1460, name: "CRANE OPERATOR" },
  { id: 1461, name: "FORKLIFT OPERATOR" },
  { id: 1462, name: "TOWER CRANE OPERATOR" },
  { id: 1463, name: "ABLE SEAMAN" },
  { id: 1464, name: "SEAMAN" },
  { id: 1465, name: "SHIP CREW" },
  { id: 1466, name: "SEAMAN (GOV)" },
  { id: 1467, name: "LAUNCH SERVICE SUPERVISOR (GOV)" },
  { id: 1468, name: "FLOWER VENDOR" },
  { id: 1469, name: "STREET NON-FOOD VENDOR" },
  { id: 1470, name: "PROMO SALESPERSON" },
  { id: 1471, name: "ERRAND BOY" },
  { id: 1472, name: "SHOES REPAIRMAN" },
  { id: 1473, name: "STREET CAR WASHER" },
  { id: 1474, name: "DOMESTIC CLEANER" },
  { id: 1475, name: "DOMESTIC HELPER" },
  { id: 1476, name: "HOUSEBOY" },
  { id: 1477, name: "HOUSEMAID" },
  { id: 1478, name: "BUTLER" },
  { id: 1479, name: "HOUSEKEEPING SERVICES ASSISTANT (GOV)" },
  { id: 1480, name: "HOUSEPARENT (GOV)" },
  { id: 1481, name: "HOUSEHOLD ATTENDANT" },
  { id: 1482, name: "BELLBOY" },
  { id: 1483, name: "CHAMBERMAID" },
  { id: 1484, name: "HOTEL CLEANER" },
  { id: 1485, name: "OFFICE CLEANER" },
  { id: 1486, name: "JANITOR" },
  { id: 1487, name: "HOSPITAL HOUSEKEEPER (GOV)" },
  { id: 1488, name: "LABORATORY AIDE II (A) (GOV)" },
  { id: 1489, name: "LEGISLATIVE STAFF EMPLOYEE (GOV)" },
  { id: 1490, name: "JANITRESS" },
  { id: 1491, name: "ROOM ATTENDANT" },
  { id: 1492, name: "TOOLKEEPER" },
  { id: 1493, name: "FUEL/GAS ATTENDANT" },
  { id: 1494, name: "RECREATION FACILITIES ATTENDANT/AIDE" },
  { id: 1495, name: "LABORATORY ASSISTANT" },
  { id: 1496, name: "LABORATORY AIDE" },
  { id: 1497, name: "GASOLINE PUMP BOY" },
  { id: 1498, name: "PRINTING ASSISTANT" },
  { id: 1499, name: "DRY CLEANER (HAND)" },
  { id: 1500, name: "BUILDING CARETAKER (CLEANING)" },
  { id: 1501, name: "UTILITYMAN" },
  { id: 1502, name: "UTILITY WORKER" },
  { id: 1503, name: "ELEVATOR OPERATOR" },
  { id: 1504, name: "MUSEUM CARETAKER" },
  { id: 1505, name: "CARETAKER (HOME-BASE)" },
  { id: 1506, name: "VEHICLE WASHER" },
  { id: 1507, name: "BAGGAGE PORTER" },
  { id: 1508, name: "DELIVERYMAN" },
  { id: 1509, name: "MESSENGER" },
  { id: 1510, name: "LUGGAGE PORTER" },
  { id: 1511, name: "POST RUNNER" },
  { id: 1512, name: "PORTER (GOV)" },
  { id: 1513, name: "MESSENGER (GOV)" },
  { id: 1514, name: "COURIER" },
  { id: 1515, name: "WAREHOUSE HELPER" },
  { id: 1516, name: "BARKER" },
  { id: 1517, name: "TICKET COLLECTOR" },
  { id: 1518, name: "DOORKEEPER" },
  { id: 1519, name: "GOLF CADDIE" },
  { id: 1520, name: "FARM WATCHER" },
  { id: 1521, name: "GATE/CROSSING KEEPER (GOV)" },
  { id: 1522, name: "GUESTHOUSE CARETAKER (GOV)" },
  { id: 1523, name: "PARKING ATTENDANT" },
  { id: 1524, name: "CARWASH ATTENDANT" },
  { id: 1525, name: "GARBAGE COLLECTOR" },
  { id: 1526, name: "ODD JOB PERSON" },
  { id: 1527, name: "STREET SWEEPER" },
  { id: 1528, name: "GARDEN HELPER" },
  { id: 1529, name: "GARDENER" },
  { id: 1530, name: "PEST CONTROL WORKER" },
  { id: 1531, name: "FARM WORKER (GOV)" },
  { id: 1532, name: "FARM WORKER" },
  { id: 1533, name: "AGRICULTURAL EXTENSION WORKER" },
  { id: 1534, name: "FORESTRY LABORER" },
  { id: 1535, name: "FISHERY HELPER" },
  { id: 1536, name: "FISHERY LABORER" },
  { id: 1537, name: "LABORER/HELPER, FISHERY" },
  { id: 1538, name: "MINING LABORER" },
  { id: 1539, name: "CONSTRUCTION LABORER" },
  { id: 1540, name: "MAINTENANCE LABORER" },
  { id: 1541, name: "ENGINEERING AIDE A (GOV)" },
  { id: 1542, name: "ENGINEERING ASSISTANT (GOV)" },
  { id: 1543, name: "MECHANICAL HELPER (GOV)" },
  { id: 1544, name: "MECHANICAL HELPER" },
  { id: 1545, name: "ENGINEERING AIDE" },
  { id: 1546, name: "LEADMAN (GENERAL)" },
  { id: 1547, name: "ENGINEERING ASSISTANT" },
  { id: 1548, name: "MAINTENANCE CREW" },
  { id: 1549, name: "WATER MAINTENANCE MAN" },
  { id: 1550, name: "CONSTRUCTION LABORER (BUILDING)" },
  { id: 1551, name: "BUILDING HELPER (GOV)" },
  { id: 1552, name: "BOTTLE SORTER" },
  { id: 1553, name: "HANDICRAFT LABORER (UNSKILLED)" },
  { id: 1554, name: "ASSEMBLING LABORER" },
  { id: 1555, name: "LABORER (GOV)" },
  { id: 1556, name: "PRODUCTION WORKER" },
  { id: 1557, name: "HELPER TECHNICIAN" },
  { id: 1558, name: "LABORER" },
  { id: 1559, name: "CART PUSHER" },
  { id: 1560, name: "MECHANIC HELPER" },
  { id: 1561, name: "FREIGHT HANDLER" },
  { id: 1562, name: "WAREHOUSE PORTER" },
  { id: 1563, name: "TRUCK HELPER" },
  { id: 1564, name: "DELIVERY HELPER" },
  { id: 1565, name: "ADMINISTRATION SERVICES AIDE" },
  { id: 1566, name: "FINGERPRINTING AIDE (GOV)" },
  { id: 1567, name: "MEDIA PRODUCTION AIDE (GOV)" },
  { id: 1568, name: "CLERICAL AIDE" },
  { id: 1569, name: "RETAIL/WHOLESALE ESTABLISHMENT SALESPERSON" },
  { id: 1570, name: "SALESLADY" },
  { id: 1571, name: "SALES CLERK" },
  { id: 1572, name: "WHOLESALE AND RETAIL TRADE SALESMAN" },
  { id: 1573, name: "PROMO STAFF" },
  { id: 1574, name: "MERCHANDISING OFFICER" },
  { id: 1575, name: "PACKAGE COUNTER CLERK" },
  { id: 1576, name: "DISPATCHER (SALES SERVICES)" },
  { id: 1577, name: "MARKET SALESPERSON" },
  { id: 1578, name: "STALL SALESPERSON" },
  { id: 1579, name: "STREET STALL SALESPERSON" },
  { id: 1580, name: "KIOSK SALESPERSON" },
  { id: 1581, name: "STORE SALESPERSON" },
  { id: 1582, name: "CHECKER" },
  { id: 1583, name: "STOCKMAN" },
  { id: 1584, name: "BAGGER" },
  { id: 1585, name: "DELIVERY CHECKER" },
  { id: 1586, name: "STORE HELPER" },
  { id: 1587, name: "MASSAGE THERAPIST" },
];

@Injectable({
  providedIn: "root",
})
export class OccupationService {
  getAllFoodHandler() {
    return allFoodHandler;
  }

  getAllNonFoodHandler() {
    return allNonFoodHandler;
  }
}
